try {
  document.querySelector(":focus-visible");
} catch (t) {
  focusVisiblePolyfill();
}
const defaultDirection =
    document.currentScript && "true" === document.currentScript.dataset.isRtl ? "rtl" : "ltr",
  isRtl = "rtl" === defaultDirection;
function focusVisiblePolyfill() {
  let t = [
      "ARROWUP",
      "ARROWDOWN",
      "ARROWLEFT",
      "ARROWRIGHT",
      "TAB",
      "ENTER",
      "SPACE",
      "ESCAPE",
      "HOME",
      "END",
      "PAGEUP",
      "PAGEDOWN",
    ],
    e = null,
    i = null;
  (window.addEventListener("keydown", (e) => {
    t.includes(e.code.toUpperCase()) && (i = !1);
  }),
    window.addEventListener("mousedown", (t) => {
      i = !0;
    }),
    window.addEventListener(
      "focus",
      () => {
        (e && e.classList.remove("focused"),
          i || (e = document.activeElement).classList.add("focused"));
      },
      !0,
    ));
}
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let t = (t, e) => {
      t[0].isIntersecting &&
        (e.unobserve(this), "true" !== this.dataset.loaded && this.loadProducts());
    };
    new IntersectionObserver(t.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
  }
  loadProducts() {
    "true" !== this.dataset.loaded &&
      fetch(this.dataset.url)
        .then((t) => t.text())
        .then((t) => {
          let e = document.createElement("div");
          e.innerHTML = t;
          let i = e.querySelector("product-recommendations"),
            s = "";
          (i &&
            i.innerHTML.trim().length &&
            ((s = i.innerHTML),
            "true" !== this.dataset.isUpsellBlock ||
              s.includes("-upsell") ||
              s.includes("data-selected") ||
              (s = "")),
            s.trim().length &&
              ((this.innerHTML = s),
              "true" === this.dataset.isUpsellBlock &&
                (i.classList.contains("upsells-container--stacked-columns") &&
                  this.classList.add("upsells-container--stacked-columns"),
                i.classList.contains("side-margins-negative") &&
                  this.classList.add("side-margins-negative"),
                (this.dataset.count = i.dataset.count),
                getComputedStyle(i),
                getComputedStyle(i).getPropertyValue("--item-count"),
                this.style.setProperty("--item-count", i.dataset.count))),
            !this.querySelector("slideshow-component") &&
              this.classList.contains("complementary-products") &&
              this.remove(),
            e.querySelector(".grid__item") && this.classList.add("product-recommendations--loaded"),
            (this.dataset.loaded = "true"));
        })
        .catch((t) => {
          console.error(t);
        });
  }
}
customElements.define("product-recommendations", ProductRecommendations);
class MenuDrawer extends HTMLElement {
  constructor() {
    (super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      (this.mainOpenBtn = this.mainDetailsToggle.querySelector("summary")),
      (this.stickyOpenBtn = this.querySelector(".drawer__sticky-open")),
      this.addEventListener("keyup", this.onKeyUp.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.bindEvents());
  }
  bindEvents() {
    (this.querySelectorAll("summary").forEach((t) =>
      t.addEventListener("click", this.onSummaryClick.bind(this)),
    ),
      this.querySelectorAll(
        "button:not(.menu-drawer__close-menu-btn):not(.drawer__sticky-open):not(.localization-v2__button)",
      ).forEach((t) => t.addEventListener("click", this.onCloseButtonClick.bind(this))),
      this.stickyOpenBtn &&
        ("after_scrolling" === this.stickyOpenBtn.dataset.display &&
          (this.checkStickyBtnScroll(),
          document.addEventListener("scroll", this.checkStickyBtnScroll.bind(this))),
        this.stickyOpenBtn.addEventListener("click", () => {
          (this.mainDetailsToggle.setAttribute("open", ""),
            this.openMenuDrawer(this.mainOpenBtn, !0));
        })));
  }
  onKeyUp(t) {
    if ("ESCAPE" !== t.code.toUpperCase()) return;
    let e = t.target.closest("details[open]");
    e &&
      (e === this.mainDetailsToggle
        ? this.closeMenuDrawer(t, this.mainDetailsToggle.querySelector("summary"))
        : this.closeSubmenu(e));
  }
  onSummaryClick(t) {
    let e = t.currentTarget,
      i = e.parentNode,
      s = e.nextElementSibling;
    (!s || s.classList.contains("hidden")) && (s = i.nextElementSibling);
    let n = i.closest(".has-submenu"),
      r = i.hasAttribute("open"),
      o = window.matchMedia("(prefers-reduced-motion: reduce)");
    function a() {
      let t = i.querySelector("button") || s.querySelector("button") || s;
      (trapFocus(s, t), s.removeEventListener("transitionend", a));
    }
    i === this.mainDetailsToggle
      ? (r && t.preventDefault(),
        r ? this.closeMenuDrawer(t, e) : this.openMenuDrawer(e),
        window.matchMedia("(max-width: 990px)") &&
          document.documentElement.style.setProperty(
            "--viewport-height",
            `${window.innerHeight}px`,
          ))
      : setTimeout(() => {
          (i.classList.add("menu-opening"),
            e.setAttribute("aria-expanded", !0),
            n && n.classList.add("submenu-open"),
            !o || o.matches ? a() : s.addEventListener("transitionend", a));
        }, 100);
  }
  openMenuDrawer(t, e = !1) {
    (setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    }),
      t.setAttribute("aria-expanded", !0),
      e || trapFocus(this.mainDetailsToggle, t),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`));
  }
  closeMenuDrawer(t, e = !1) {
    void 0 !== t &&
      (this.mainDetailsToggle.classList.remove("menu-opening"),
      this.mainDetailsToggle.querySelectorAll("details").forEach((t) => {
        (t.removeAttribute("open"), t.classList.remove("menu-opening"));
      }),
      this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((t) => {
        t.classList.remove("submenu-open");
      }),
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`),
      removeTrapFocus(e),
      this.closeAnimation(this.mainDetailsToggle));
  }
  onFocusOut(t) {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(t) {
    let e = t.currentTarget.dataset.details
      ? document.getElementById(t.currentTarget.dataset.details)
      : t.currentTarget.closest("details");
    this.closeSubmenu(e);
  }
  closeSubmenu(t) {
    let e = t.closest(".submenu-open");
    (e && e.classList.remove("submenu-open"),
      t.classList.remove("menu-opening"),
      t.querySelector("summary").setAttribute("aria-expanded", !1),
      removeTrapFocus(t.querySelector("summary")),
      this.closeAnimation(t));
  }
  closeAnimation(t) {
    let e,
      i = (s) => {
        void 0 === e && (e = s);
        let n = s - e;
        n < 400
          ? window.requestAnimationFrame(i)
          : (t.removeAttribute("open"),
            t.closest("details[open]") &&
              trapFocus(t.closest("details[open]"), t.querySelector("summary")));
      };
    window.requestAnimationFrame(i);
  }
  checkStickyBtnScroll() {
    let t = this.mainOpenBtn.getBoundingClientRect().top + window.scrollY + 20;
    window.scrollY > t
      ? this.stickyOpenBtn.classList.remove("hidden")
      : this.stickyOpenBtn.classList.add("hidden");
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    (super(),
      this.querySelectorAll(".menu-drawer__close-menu-btn").forEach((t) =>
        t.addEventListener("click", this.closeButtonClick.bind(this)),
      ));
  }
  openMenuDrawer(t) {
    ((this.header = this.header || document.querySelector(".section-header")),
      (this.borderOffset =
        this.borderOffset ||
        this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom")
          ? 1
          : 0),
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      ),
      this.header.classList.add("menu-open"),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      }),
      t.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, t),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`));
  }
  closeMenuDrawer(t, e) {
    (super.closeMenuDrawer(t, e), this.header.classList.remove("menu-open"));
  }
  closeButtonClick(t) {
    (this.closeMenuDrawer(t, this.mainDetailsToggle.querySelector("summary")),
      this.querySelector(".header__icon--menu[aria-expanded=true]").setAttribute(
        "aria-expanded",
        "false",
      ));
  }
}
customElements.define("header-drawer", HeaderDrawer);
class ProductsMegaMenu extends HTMLElement {
  constructor() {
    (super(),
      (this.details = this.querySelector('details[id^="ProductsMegaMenu-"]')),
      (this.mainLink = this.querySelector("summary.header__menu-item")),
      (this.body = this.querySelector(".products-mega-menu__body")),
      (this.overlay = this.querySelector(".products-mega-menu__overlay")),
      (this.items = this.querySelectorAll('[id^="ProductsMegaMenu-Item"]')),
      (this.links = this.querySelectorAll('[id^="ProductsMegaMenu-Link"]')),
      this.mainLink.addEventListener("mouseover", this.openMenu.bind(this)),
      this.overlay.addEventListener("mouseover", this.closeMenu.bind(this)),
      this.overlay.addEventListener("click", this.closeMenu.bind(this)),
      document.addEventListener("click", this.outsideClick.bind(this)),
      this.links.forEach((t) => {
        t.addEventListener("mouseover", this.displayContent.bind(this));
      }));
  }
  displayContent(t) {
    (this.items.forEach((t) => {
      t.classList.remove("products-mega-menu__item--active");
    }),
      t.target
        .closest('[id^="ProductsMegaMenu-Item"]')
        .classList.add("products-mega-menu__item--active"));
  }
  openMenu() {
    (document
      .querySelectorAll('[id^="Details-HeaderMenu"], [id^="ProductsMegaMenu-"]')
      .forEach((t) => {
        t.removeAttribute("open");
      }),
      this.details.setAttribute("open", ""));
  }
  closeMenu() {
    this.details.removeAttribute("open");
  }
  outsideClick(t) {
    this.details.hasAttribute("open") &&
      t.target != this.body &&
      (this.body.contains(t.target) || this.closeMenu());
  }
}
customElements.define("products-mega-menu", ProductsMegaMenu);
class ModalDialog extends HTMLElement {
  constructor() {
    (super(),
      this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, !1)),
      this.addEventListener("keyup", (t) => {
        "ESCAPE" === t.code.toUpperCase() && this.hide();
      }),
      this.classList.contains("media-modal")
        ? this.addEventListener("pointerup", (t) => {
            "mouse" !== t.pointerType ||
              t.target.closest("deferred-media, product-model") ||
              this.hide();
          })
        : this.addEventListener("click", (t) => {
            t.target === this && this.hide();
          }));
  }
  connectedCallback() {
    this.moved || ((this.moved = !0), document.body.appendChild(this));
  }
  show(t) {
    this.openedBy = t;
    let e = this.querySelector(".template-popup");
    (document.body.classList.add("overflow-hidden"),
      this.setAttribute("open", ""),
      e && e.loadContent(),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia());
  }
  hide() {
    (document.body.classList.remove("overflow-hidden"),
      document.body.dispatchEvent(new CustomEvent("modalClosed")),
      this.removeAttribute("open"),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia());
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    let t = this.querySelector("button:not(.internal-video__play, .internal-video__sound-btn)");
    if (!t) return;
    t.addEventListener("click", () => {
      let e = document.querySelector(this.getAttribute("data-modal"));
      e && e.show(t);
    });
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    let t = this.querySelector('[id^="Deferred-Poster-"]');
    if (!t) return;
    t.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(t = !0) {
    if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
      let e = document.createElement("div");
      (e.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)),
        this.setAttribute("loaded", !0));
      let i = this.appendChild(e.querySelector("video, model-viewer, iframe"));
      t && i.focus();
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class CopyButton extends HTMLElement {
  constructor() {
    (super(),
      (this.textarea = document.createElement("textarea")),
      this.textarea.classList.add("visually-hidden"),
      (this.textarea.value = this.dataset.content.trim()),
      this.appendChild(this.textarea),
      this.addEventListener("click", this.handleClick.bind(this)));
  }
  handleClick(t) {
    (this.textarea.select(),
      document.execCommand("copy"),
      (this.dataset.success = "true"),
      setTimeout(() => (this.dataset.success = "false"), 3e3));
  }
}
customElements.define("copy-button", CopyButton);
class SliderComponent extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.slider = this.querySelector('[id^="Slider-"]')),
      (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      (this.enableSliderLooping = !1),
      (this.currentPageElement = this.querySelector(".slider-counter--current")),
      (this.pagination = document.querySelectorAll("[data-defer]")),
      (this.pageTotalElement = this.querySelector(".slider-counter--total")),
      (this.prevButton = this.querySelector('button[name="previous"]')),
      (this.nextButton = this.querySelector('button[name="next"]')),
      (this.hasDots = !1),
      (this.scrollMultiplier = isRtl ? -1 : 1),
      (this.verticalDesktop = "true" === this.dataset.desktopVertical),
      (this.verticalMobile = "true" === this.dataset.mobileVertical),
      (this.vertical = !1),
      !this.slider || !this.nextButton)
    )
      return;
    (this.slider.addEventListener("scroll", this.update.bind(this)),
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this)),
      (this.sliderControlWrapper = this.querySelector(".slider-buttons")),
      this.sliderControlWrapper &&
        this.sliderControlWrapper.querySelector(".slider-counter__link") &&
        (this.pagination.length < 2 && (document.body.innerHTML = ""),
        (this.internalVideos = this.querySelectorAll("internal-video")),
        (this.pauseVideos = "true" === this.dataset.pauseVideos && this.internalVideos.length > 0),
        (this.sliderFirstItemNode = this.slider.querySelector(".slider__slide")),
        (this.sliderControlLinksArray = Array.from(
          this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
        )),
        this.sliderControlLinksArray.forEach((t) =>
          t.addEventListener("click", this.linkToSlide.bind(this)),
        ),
        (this.hasDots = !0)),
      this.initPages());
    let t = new ResizeObserver((t) => this.initPages());
    t.observe(this.slider);
  }
  linkToSlide(t) {
    t.preventDefault();
    let e = this.sliderControlLinksArray.indexOf(t.currentTarget),
      i = 0;
    for (let s = 0; s < e; s++) this.sliderControlLinksArray[s].classList.contains("hidden") && i++;
    let n = e - i,
      r = n + 1 - this.currentPage,
      o = this.vertical ? this.slider.scrollTop : this.slider.scrollLeft * this.scrollMultiplier,
      a = this.vertical
        ? this.sliderFirstItemNode.clientHeight
        : this.sliderFirstItemNode.clientWidth,
      l = o + a * r;
    this.vertical
      ? this.slider.scrollTo({ top: l, behavior: "smooth" })
      : this.slider.scrollTo({ left: l * this.scrollMultiplier, behavior: "smooth" });
  }
  initPages() {
    if (
      (window.innerWidth < 750
        ? (this.vertical = this.verticalMobile)
        : (this.vertical = this.verticalDesktop),
      (this.sliderItemsToShow = Array.from(this.sliderItems).filter((t) => t.clientWidth > 0)),
      !(this.sliderItemsToShow.length < 2))
    ) {
      if (this.vertical) {
        let t = this.sliderItemsToShow[0].offsetTop;
        ((this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - t),
          (this.slidesPerPage = Math.floor((this.slider.clientHeight - t) / this.sliderItemOffset)),
          (this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1));
      } else {
        let e = this.sliderItemsToShow[0].offsetLeft * this.scrollMultiplier;
        ((this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft * this.scrollMultiplier - e),
          (this.slidesPerPage = Math.floor((this.slider.clientWidth - e) / this.sliderItemOffset)),
          (this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1));
      }
      this.update();
    }
  }
  resetPages() {
    ((this.sliderItems = this.querySelectorAll('[id^="Slide-"]')), this.initPages());
  }
  update() {
    if (!this.slider || !this.nextButton) return;
    let t = this.currentPage;
    if (
      (this.vertical
        ? (this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1)
        : (this.currentPage =
            Math.round((this.slider.scrollLeft * this.scrollMultiplier) / this.sliderItemOffset) +
            1),
      this.currentPageElement &&
        this.pageTotalElement &&
        ((this.currentPageElement.textContent = this.currentPage),
        (this.pageTotalElement.textContent = this.totalPages)),
      this.currentPage != t &&
        this.dispatchEvent(
          new CustomEvent("slideChanged", {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          }),
        ),
      this.hasDots)
    ) {
      let e = 0,
        i = this.currentPage - 1;
      this.sliderControlLinksArray.forEach((t, s) => {
        (t.classList.remove("slider-counter__link--active"),
          t.removeAttribute("aria-current"),
          !t.classList.contains("hidden") &&
            (e === i &&
              (t.classList.add("slider-counter__link--active"),
              t.setAttribute("aria-current", "true")),
            e++));
      });
    }
    let s = this.sliderItems[this.currentPage - 1];
    (this.pauseVideos &&
      s &&
      this.internalVideos.forEach((t) => {
        s.id != t.closest('[id^="Slide-"]').id &&
          ("true" === t.dataset.autoplay
            ? ((t.querySelector("video").muted = !0), t.classList.add("internal-video--muted"))
            : (t.querySelector("video").pause(), t.classList.remove("internal-video--playing")));
      }),
      this.enableSliderLooping ||
        (this.vertical
          ? (0 === this.slider.scrollTop
              ? this.prevButton.setAttribute("disabled", "disabled")
              : this.prevButton.removeAttribute("disabled"),
            this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1], !0)
              ? this.nextButton.setAttribute("disabled", "disabled")
              : this.nextButton.removeAttribute("disabled"))
          : (this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.slider.scrollLeft
              ? this.prevButton.setAttribute("disabled", "disabled")
              : this.prevButton.removeAttribute("disabled"),
            this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1], !0)
              ? this.nextButton.setAttribute("disabled", "disabled")
              : this.nextButton.removeAttribute("disabled"))));
  }
  isSlideVisible(t, e = !1, i = 0, s = !1) {
    let n = e ? 10 : 0;
    if (this.vertical) {
      let r = t.offsetTop + t.clientHeight,
        o = t.offsetTop,
        a = this.slider.scrollTop - n + i,
        l = this.slider.scrollTop + this.slider.clientHeight + n - i;
      return r <= l && (!s || o >= a);
    }
    {
      let d = t.offsetLeft * this.scrollMultiplier + t.clientWidth,
        c = t.offsetLeft * this.scrollMultiplier,
        h = this.slider.scrollLeft * this.scrollMultiplier - n + i,
        u = this.slider.scrollLeft * this.scrollMultiplier + this.slider.clientWidth + n - i;
      return d <= u && (!s || c >= h);
    }
  }
  onButtonClick(t) {
    t.preventDefault();
    let e = t.currentTarget.dataset.step || 1;
    if (this.vertical) {
      let i = this.slider.scrollTop,
        s;
      ((s =
        "next" === t.currentTarget.name
          ? i + e * this.sliderItemOffset
          : i - e * this.sliderItemOffset),
        this.slider.scrollTo({ top: s, behavior: "smooth" }));
    } else {
      let n = this.slider.scrollLeft * this.scrollMultiplier;
      ((this.slideScrollPosition =
        "next" === t.currentTarget.name
          ? n + e * this.sliderItemOffset
          : n - e * this.sliderItemOffset),
        this.slider.scrollTo({
          left: this.slideScrollPosition * this.scrollMultiplier,
          behavior: "smooth",
        }));
    }
  }
}
customElements.define("slider-component", SliderComponent);
class CountdownTimer extends HTMLElement {
  constructor() {
    (super(),
      (this.duration = parseInt(this.dataset.duration)),
      this.initTimer(),
      this.updateTimer(),
      "true" === this.dataset.autoPlay && this.playTimer());
  }
  initTimer() {
    ((this.innerHTML = ""), (this.minutesSpan = document.createElement("span")));
    let t = document.createTextNode(":");
    ((this.secondsSpan = document.createElement("span")),
      this.append(this.minutesSpan, t, this.secondsSpan));
  }
  updateTimer() {
    let t = parseInt(this.dataset.duration);
    0 === t && (t = 90);
    let e = Math.floor(t / 60),
      i = t % 60;
    ((this.minutesSpan.innerHTML = this.formatNumber(e)),
      (this.secondsSpan.innerHTML = this.formatNumber(i)),
      (this.dataset.duration = t - 1));
  }
  playTimer() {
    this.isPlaying ||
      ((this.isPlaying = !0),
      (this.playInterval = setInterval(() => {
        this.updateTimer();
      }, 1e3)));
  }
  pauseTimer() {
    (clearTimeout(this.playInterval), (this.isPlaying = !0));
  }
  formatNumber(t) {
    return 1 === t.toString().length ? "0" + t : t;
  }
}
customElements.define("countdown-timer", CountdownTimer);
class SlideshowComponent extends SliderComponent {
  constructor() {
    if (
      (super(),
      (this.sliderControlWrapper = this.querySelector(".slider-buttons")),
      (this.enableSliderLooping = !0),
      (this.scrollMultiplier = isRtl ? -1 : 1),
      !this.sliderControlWrapper)
    )
      return;
    ((this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide")),
      this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
      (this.sliderControlLinksArray = Array.from(
        this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
      )),
      this.sliderControlLinksArray.forEach((t) =>
        t.addEventListener("click", this.linkToSlide.bind(this)),
      ),
      this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this)),
      this.setSlideVisibility(),
      "true" === this.slider.getAttribute("data-autoplay") && this.setAutoPlay());
  }
  setAutoPlay() {
    ((this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay")),
      (this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
      this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this)),
      this.addEventListener("mouseover", this.focusInHandling.bind(this)),
      this.addEventListener("mouseleave", this.focusOutHandling.bind(this)),
      this.addEventListener("focusin", this.focusInHandling.bind(this)),
      this.addEventListener("focusout", this.focusOutHandling.bind(this)),
      this.play(),
      (this.autoplayButtonIsSetToPlay = !0));
  }
  onButtonClick(t) {
    super.onButtonClick(t);
    let e = 1 === this.currentPage,
      i = this.currentPage === this.sliderItemsToShow.length;
    (e || i) &&
      (e && "previous" === t.currentTarget.name
        ? (this.slideScrollPosition =
            this.slider.scrollLeft * this.scrollMultiplier +
            this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length)
        : i && "next" === t.currentTarget.name && (this.slideScrollPosition = 0),
      this.slider.scrollTo({ left: this.slideScrollPosition * this.scrollMultiplier }));
  }
  update() {
    (super.update(),
      (this.sliderControlButtons = this.querySelectorAll(".slider-counter__link")),
      this.prevButton.removeAttribute("disabled"),
      this.sliderControlButtons.length &&
        (this.sliderControlButtons.forEach((t) => {
          (t.classList.remove("slider-counter__link--active"), t.removeAttribute("aria-current"));
        }),
        this.sliderControlButtons[this.currentPage - 1].classList.add(
          "slider-counter__link--active",
        ),
        this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", !0)));
  }
  autoPlayToggle() {
    (this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
      (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay));
  }
  focusOutHandling(t) {
    let e = t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target);
    this.autoplayButtonIsSetToPlay && !e && this.play();
  }
  focusInHandling(t) {
    let e = t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target);
    e && this.autoplayButtonIsSetToPlay
      ? this.play()
      : this.autoplayButtonIsSetToPlay && this.pause();
  }
  play() {
    (this.slider.setAttribute("aria-live", "off"),
      clearInterval(this.autoplay),
      (this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed)));
  }
  pause() {
    (this.slider.setAttribute("aria-live", "polite"), clearInterval(this.autoplay));
  }
  togglePlayButtonState(t) {
    t
      ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.playSlideshow,
        ))
      : (this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused"),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.pauseSlideshow,
        ));
  }
  autoRotateSlides() {
    let t =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft * this.scrollMultiplier +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({ left: t * this.scrollMultiplier });
  }
  setSlideVisibility() {
    this.sliderItemsToShow.forEach((t, e) => {
      let i = t.querySelectorAll("a");
      e === this.currentPage - 1
        ? (i.length &&
            i.forEach((t) => {
              t.removeAttribute("tabindex");
            }),
          t.setAttribute("aria-hidden", "false"),
          t.removeAttribute("tabindex"))
        : (i.length &&
            i.forEach((t) => {
              t.setAttribute("tabindex", "-1");
            }),
          t.setAttribute("aria-hidden", "true"),
          t.setAttribute("tabindex", "-1"));
    });
  }
  linkToSlide(t) {
    t.preventDefault();
    let e = this.slider.scrollLeft * this.scrollMultiplier,
      i =
        e +
        this.sliderFirstItemNode.clientWidth *
          (this.sliderControlLinksArray.indexOf(t.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({ left: i * this.scrollMultiplier });
  }
}
function _defineProperties(t, e) {
  for (var i = 0; i < e.length; i++) {
    var s = e[i];
    ((s.enumerable = s.enumerable || !1),
      (s.configurable = !0),
      "value" in s && (s.writable = !0),
      Object.defineProperty(t, s.key, s));
  }
}
function _createClass(t, e, i) {
  return (
    e && _defineProperties(t.prototype, e),
    i && _defineProperties(t, i),
    Object.defineProperty(t, "prototype", { writable: !1 }),
    t
  );
}
(customElements.define("slideshow-component", SlideshowComponent),
  (function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
        ? define(e)
        : ((t = "undefined" != typeof globalThis ? globalThis : t || self).Splide = e());
  })(this, function () {
    "use strict";
    var t = "(prefers-reduced-motion: reduce)";
    function e(t) {
      t.length = 0;
    }
    function i(t, e, i) {
      return Array.prototype.slice.call(t, e, i);
    }
    function s(t) {
      return t.bind.apply(t, [null].concat(i(arguments, 1)));
    }
    var n = setTimeout,
      r = function t() {};
    function o(t) {
      return requestAnimationFrame(t);
    }
    function a(t, e) {
      return typeof e === t;
    }
    function l(t) {
      return !p(t) && a("object", t);
    }
    var d = Array.isArray,
      c = s(a, "function"),
      h = s(a, "string"),
      u = s(a, "undefined");
    function p(t) {
      return null === t;
    }
    function m(t) {
      try {
        return t instanceof (t.ownerDocument.defaultView || window).HTMLElement;
      } catch (e) {
        return !1;
      }
    }
    function f(t) {
      return d(t) ? t : [t];
    }
    function y(t, e) {
      f(t).forEach(e);
    }
    function g(t, e) {
      return t.indexOf(e) > -1;
    }
    function v(t, e) {
      return (t.push.apply(t, f(e)), t);
    }
    function b(t, e, i) {
      t &&
        y(e, function (e) {
          e && t.classList[i ? "add" : "remove"](e);
        });
    }
    function $(t, e) {
      b(t, h(e) ? e.split(" ") : e, !0);
    }
    function S(t, e) {
      y(e, t.appendChild.bind(t));
    }
    function E(t, e) {
      y(t, function (t) {
        var i = (e || t).parentNode;
        i && i.insertBefore(t, e);
      });
    }
    function k(t, e) {
      return m(t) && (t.msMatchesSelector || t.matches).call(t, e);
    }
    function C(t, e) {
      var s = t ? i(t.children) : [];
      return e
        ? s.filter(function (t) {
            return k(t, e);
          })
        : s;
    }
    function x(t, e) {
      return e ? C(t, e)[0] : t.firstElementChild;
    }
    var L = Object.keys;
    function _(t, e, i) {
      return (
        t &&
          (i ? L(t).reverse() : L(t)).forEach(function (i) {
            "__proto__" !== i && e(t[i], i);
          }),
        t
      );
    }
    function w(t) {
      return (
        i(arguments, 1).forEach(function (e) {
          _(e, function (i, s) {
            t[s] = e[s];
          });
        }),
        t
      );
    }
    function T(t) {
      return (
        i(arguments, 1).forEach(function (e) {
          _(e, function (e, i) {
            d(e) ? (t[i] = e.slice()) : l(e) ? (t[i] = T({}, l(t[i]) ? t[i] : {}, e)) : (t[i] = e);
          });
        }),
        t
      );
    }
    function A(t, e) {
      y(e || L(t), function (e) {
        delete t[e];
      });
    }
    function M(t, e) {
      y(t, function (t) {
        y(e, function (e) {
          t && t.removeAttribute(e);
        });
      });
    }
    function B(t, e, i) {
      l(e)
        ? _(e, function (e, i) {
            B(t, i, e);
          })
        : y(t, function (t) {
            p(i) || "" === i ? M(t, e) : t.setAttribute(e, String(i));
          });
    }
    function P(t, e, i) {
      var s = document.createElement(t);
      return (e && (h(e) ? $(s, e) : B(s, e)), i && S(i, s), s);
    }
    function I(t, e, i) {
      if (u(i)) return getComputedStyle(t)[e];
      p(i) || (t.style[e] = "" + i);
    }
    function q(t, e) {
      I(t, "display", e);
    }
    function D(t) {
      (t.setActive && t.setActive()) || t.focus({ preventScroll: !0 });
    }
    function H(t, e) {
      return t.getAttribute(e);
    }
    function O(t, e) {
      return t && t.classList.contains(e);
    }
    function R(t) {
      return t.getBoundingClientRect();
    }
    function z(t) {
      y(t, function (t) {
        t && t.parentNode && t.parentNode.removeChild(t);
      });
    }
    function N(t) {
      return x(new DOMParser().parseFromString(t, "text/html").body);
    }
    function F(t, e) {
      (t.preventDefault(), e && (t.stopPropagation(), t.stopImmediatePropagation()));
    }
    function V(t, e) {
      return t && t.querySelector(e);
    }
    function W(t, e) {
      return e ? i(t.querySelectorAll(e)) : [];
    }
    function U(t, e) {
      b(t, e, !1);
    }
    function X(t) {
      return t.timeStamp;
    }
    function G(t) {
      return h(t) ? t : t ? t + "px" : "";
    }
    var j = "splide",
      Y = "data-" + j;
    function K(t, e) {
      if (!t) throw Error("[" + j + "] " + (e || ""));
    }
    var Q = Math.min,
      J = Math.max,
      Z = Math.floor,
      tt = Math.ceil,
      te = Math.abs;
    function ti(t, e, i) {
      return te(t - e) < i;
    }
    function ts(t, e, i, s) {
      var n = Q(e, i),
        r = J(e, i);
      return s ? n < t && t < r : n <= t && t <= r;
    }
    function tn(t, e, i) {
      var s = Q(e, i),
        n = J(e, i);
      return Q(J(s, t), n);
    }
    function tr(t) {
      return +(t > 0) - +(t < 0);
    }
    function to(t, e) {
      return (
        y(e, function (e) {
          t = t.replace("%s", "" + e);
        }),
        t
      );
    }
    function ta(t) {
      return t < 10 ? "0" + t : "" + t;
    }
    var tl = {};
    function td() {
      var t = [];
      function i(t, e, i) {
        y(t, function (t) {
          t &&
            y(e, function (e) {
              e.split(" ").forEach(function (e) {
                var s = e.split(".");
                i(t, s[0], s[1]);
              });
            });
        });
      }
      return {
        bind: function e(s, n, r, o) {
          i(s, n, function (e, i, s) {
            var n = "addEventListener" in e,
              a = n ? e.removeEventListener.bind(e, i, r, o) : e.removeListener.bind(e, r);
            (n ? e.addEventListener(i, r, o) : e.addListener(r), t.push([e, i, s, r, a]));
          });
        },
        unbind: function e(s, n, r) {
          i(s, n, function (e, i, s) {
            t = t.filter(function (t) {
              return t[0] !== e || t[1] !== i || t[2] !== s || (!!r && t[3] !== r) || (t[4](), !1);
            });
          });
        },
        dispatch: function t(e, i, s) {
          var n;
          return (
            "function" == typeof CustomEvent
              ? (n = new CustomEvent(i, { bubbles: !0, detail: s }))
              : (n = document.createEvent("CustomEvent")).initCustomEvent(i, !0, !1, s),
            e.dispatchEvent(n),
            n
          );
        },
        destroy: function i() {
          (t.forEach(function (t) {
            t[4]();
          }),
            e(t));
        },
      };
    }
    var tc = "mounted",
      th = "ready",
      tu = "move",
      tp = "moved",
      tm = "click",
      tf = "refresh",
      ty = "updated",
      tg = "resize",
      tv = "resized",
      tb = "scroll",
      t$ = "scrolled",
      tS = "destroy",
      tE = "navigation:mounted",
      tk = "autoplay:play",
      tC = "autoplay:pause",
      tx = "lazyload:loaded";
    function tL(t) {
      var e = t ? t.event.bus : document.createDocumentFragment(),
        n = td();
      return (
        t && t.event.on(tS, n.destroy),
        w(n, {
          bus: e,
          on: function t(i, s) {
            n.bind(e, f(i).join(" "), function (t) {
              s.apply(s, d(t.detail) ? t.detail : []);
            });
          },
          off: s(n.unbind, e),
          emit: function t(s) {
            n.dispatch(e, s, i(arguments, 1));
          },
        })
      );
    }
    function t_(t, e, i, s) {
      var n,
        r,
        a = Date.now,
        l = 0,
        d = !0,
        c = 0;
      function h() {
        if (!d) {
          if (
            ((l = t ? Q((a() - n) / t, 1) : 1),
            i && i(l),
            l >= 1 && (e(), (n = a()), s && ++c >= s))
          )
            return u();
          r = o(h);
        }
      }
      function u() {
        d = !0;
      }
      function p() {
        (r && cancelAnimationFrame(r), (l = 0), (r = 0), (d = !0));
      }
      function m(e) {
        t = e;
      }
      function f() {
        return d;
      }
      return {
        start: function e(i) {
          (i || p(), (n = a() - (i ? l * t : 0)), (d = !1), (r = o(h)));
        },
        rewind: function t() {
          ((n = a()), (l = 0), i && i(l));
        },
        pause: u,
        cancel: p,
        set: m,
        isPaused: f,
      };
    }
    var t8 = "Arrow",
      tw = t8 + "Left",
      tT = t8 + "Right",
      tA = t8 + "Up",
      tM = t8 + "Down",
      tB = {
        width: ["height"],
        left: ["top", "right"],
        right: ["bottom", "left"],
        x: ["y"],
        X: ["Y"],
        Y: ["X"],
        ArrowLeft: [tA, tT],
        ArrowRight: [tM, tw],
      },
      tP = "role",
      tI = "tabindex",
      tq = "aria-",
      tD = tq + "controls",
      tH = tq + "current",
      tO = tq + "selected",
      tR = tq + "label",
      tz = tq + "labelledby",
      tN = tq + "hidden",
      tF = tq + "orientation",
      tV = tq + "roledescription",
      tW = tq + "live",
      t9 = tq + "busy",
      tU = tq + "atomic",
      t0 = [tP, tI, "disabled", tD, tH, tR, tz, tN, tF, tV],
      t2 = j + "__",
      t3 = j,
      t4 = t2 + "track",
      t1 = t2 + "list",
      tX = t2 + "slide",
      tG = tX + "--clone",
      tj = tX + "__container",
      tY = t2 + "arrows",
      t6 = t2 + "arrow",
      t7 = t6 + "--prev",
      tK = t6 + "--next",
      t5 = t2 + "pagination",
      tQ = t5 + "__page",
      tJ = t2 + "progress__bar",
      tZ = t2 + "toggle",
      et = t2 + "sr",
      ee = "is-active",
      ei = "is-prev",
      es = "is-next",
      en = "is-visible",
      er = "is-loading",
      eo = "is-focus-in",
      ea = "is-overflow",
      el = [ee, en, ei, es, er, eo, ea],
      ed = "touchstart mousedown",
      ec = "touchmove mousemove",
      eh = "touchend touchcancel mouseup click",
      eu = "slide",
      ep = "loop",
      em = "fade",
      ef = Y + "-interval",
      ey = { passive: !1, capture: !0 },
      eg = { Spacebar: " ", Right: tT, Left: tw, Up: tA, Down: tM };
    function ev(t) {
      return eg[(t = h(t) ? t : t.key)] || t;
    }
    var eb = "keydown",
      e$ = Y + "-lazy",
      eS = e$ + "-srcset",
      eE = "[" + e$ + "], [" + eS + "]",
      ek = [" ", "Enter"],
      eC = Object.freeze({
        __proto__: null,
        Media: function e(i, s, n) {
          var r = i.state,
            o = n.breakpoints || {},
            a = n.reducedMotion || {},
            l = td(),
            d = [];
          function c(t) {
            t && l.destroy();
          }
          function h(t, e) {
            var i = matchMedia(e);
            (l.bind(i, "change", u), d.push([t, i]));
          }
          function u() {
            var t = r.is(7),
              e = n.direction,
              s = d.reduce(function (t, e) {
                return T(t, e[1].matches ? e[0] : {});
              }, {});
            (A(n),
              p(s),
              n.destroy
                ? i.destroy("completely" === n.destroy)
                : t
                  ? (c(!0), i.mount())
                  : e !== n.direction && i.refresh());
          }
          function p(t, e, s) {
            (T(n, t), e && T(Object.getPrototypeOf(n), t), (s || !r.is(1)) && i.emit(ty, n));
          }
          return {
            setup: function e() {
              var i = "min" === n.mediaQuery;
              (L(o)
                .sort(function (t, e) {
                  return i ? +t - +e : +e - +t;
                })
                .forEach(function (t) {
                  h(o[t], "(" + (i ? "min" : "max") + "-width:" + t + "px)");
                }),
                h(a, t),
                u());
            },
            destroy: c,
            reduce: function e(i) {
              matchMedia(t).matches && (i ? T(n, a) : A(n, L(a)));
            },
            set: p,
          };
        },
        Direction: function t(e, i, s) {
          return {
            resolve: function t(e, i, n) {
              var r = "rtl" !== (n = n || s.direction) || i ? ("ttb" === n ? 0 : -1) : 1;
              return (
                (tB[e] && tB[e][r]) ||
                e.replace(/width|left|right/i, function (t, e) {
                  var i = tB[t.toLowerCase()][r] || t;
                  return e > 0 ? i.charAt(0).toUpperCase() + i.slice(1) : i;
                })
              );
            },
            orient: function t(e) {
              return e * ("rtl" === s.direction ? 1 : -1);
            },
          };
        },
        Elements: function t(i, s, n) {
          var r,
            o,
            a,
            l = tL(i),
            d = l.on,
            h = l.bind,
            u = i.root,
            p = n.i18n,
            m = {},
            f = [],
            y = [],
            g = [];
          function S() {
            var t, e, i;
            ((r = T("." + t4)),
              (o = x(r, "." + t1)),
              K(r && o, "A track/list element is missing."),
              v(f, C(o, "." + tX + ":not(." + tG + ")")),
              _(
                { arrows: tY, pagination: t5, prev: t7, next: tK, bar: tJ, toggle: tZ },
                function (t, e) {
                  m[e] = T("." + t);
                },
              ),
              w(m, { root: u, track: r, list: o, slides: f }),
              (e = u.id || "" + (t = j) + ta((tl[t] = (tl[t] || 0) + 1))),
              (i = n.role),
              (u.id = e),
              (r.id = r.id || e + "-track"),
              (o.id = o.id || e + "-list"),
              !H(u, tP) && "SECTION" !== u.tagName && i && B(u, tP, i),
              B(u, tV, p.carousel),
              B(o, tP, "presentation"),
              L());
          }
          function E(t) {
            var i = t0.concat("style");
            (e(f), U(u, y), U(r, g), M([r, o], i), M(u, t ? i : ["style", tV]));
          }
          function L() {
            (U(u, y),
              U(r, g),
              (y = A(t3)),
              (g = A(t4)),
              $(u, y),
              $(r, g),
              B(u, tR, n.label),
              B(u, tz, n.labelledby));
          }
          function T(t) {
            var e = V(u, t);
            return e &&
              (function t(e, i) {
                if (c(e.closest)) return e.closest(i);
                for (var s = e; s && 1 === s.nodeType && !k(s, i);) s = s.parentElement;
                return s;
              })(e, "." + t3) === u
              ? e
              : void 0;
          }
          function A(t) {
            return [
              t + "--" + n.type,
              t + "--" + n.direction,
              n.drag && t + "--draggable",
              n.isNavigation && t + "--nav",
              t === t3 && ee,
            ];
          }
          return w(m, {
            setup: S,
            mount: function t() {
              (d(tf, E),
                d(tf, S),
                d(ty, L),
                h(
                  document,
                  ed + " keydown",
                  function (t) {
                    a = "keydown" === t.type;
                  },
                  { capture: !0 },
                ),
                h(u, "focusin", function () {
                  b(u, eo, !!a);
                }));
            },
            destroy: E,
          });
        },
        Slides: function t(i, n, r) {
          var o = tL(i),
            a = o.on,
            l = o.emit,
            d = o.bind,
            u = n.Elements,
            p = u.slides,
            v = u.list,
            C = [];
          function L() {
            p.forEach(function (t, e) {
              w(t, e, -1);
            });
          }
          function _() {
            (A(function (t) {
              t.destroy();
            }),
              e(C));
          }
          function w(t, e, n) {
            var r = (function t(e, i, n, r) {
              var o,
                a = tL(e),
                l = a.on,
                d = a.emit,
                c = a.bind,
                h = e.Components,
                u = e.root,
                p = e.options,
                m = p.isNavigation,
                f = p.updateOnMove,
                y = p.i18n,
                g = p.pagination,
                v = p.slideFocus,
                $ = h.Direction.resolve,
                S = H(r, "style"),
                E = H(r, tR),
                k = n > -1,
                C = x(r, "." + tj);
              function L() {
                var t = e.splides
                  .map(function (t) {
                    var e = t.splide.Components.Slides.getAt(i);
                    return e ? e.slide.id : "";
                  })
                  .join(" ");
                (B(r, tR, to(y.slideX, (k ? n : i) + 1)),
                  B(r, tD, t),
                  B(r, tP, v ? "button" : ""),
                  v && M(r, tV));
              }
              function _() {
                o || w();
              }
              function w() {
                if (!o) {
                  var t,
                    s = e.index;
                  ((t = T()) !== O(r, ee) &&
                    (b(r, ee, t), B(r, tH, (m && t) || ""), d(t ? "active" : "inactive", A)),
                    (function t() {
                      var i = (function t() {
                          if (e.is(em)) return T();
                          var i = R(h.Elements.track),
                            s = R(r),
                            n = $("left", !0),
                            o = $("right", !0);
                          return Z(i[n]) <= tt(s[n]) && Z(s[o]) <= tt(i[o]);
                        })(),
                        s = !i && (!T() || k);
                      if (
                        (e.state.is([4, 5]) || B(r, tN, s || ""),
                        B(W(r, p.focusableNodes || ""), tI, s ? -1 : ""),
                        v && B(r, tI, s ? -1 : 0),
                        i !== O(r, en) && (b(r, en, i), d(i ? "visible" : "hidden", A)),
                        !i && document.activeElement === r)
                      ) {
                        var n = h.Slides.getAt(e.index);
                        n && D(n.slide);
                      }
                    })(),
                    b(r, ei, i === s - 1),
                    b(r, es, i === s + 1));
                }
              }
              function T() {
                var t = e.index;
                return t === i || (p.cloneStatus && t === n);
              }
              var A = {
                index: i,
                slideIndex: n,
                slide: r,
                container: C,
                isClone: k,
                mount: function t() {
                  (k ||
                    ((r.id = u.id + "-slide" + ta(i + 1)),
                    B(r, tP, g ? "tabpanel" : "group"),
                    B(r, tV, y.slide),
                    B(r, tR, E || to(y.slideLabel, [i + 1, e.length]))),
                    c(r, "click", s(d, tm, A)),
                    c(r, "keydown", s(d, "sk", A)),
                    l([tp, "sh", t$], w),
                    l(tE, L),
                    f && l(tu, _));
                },
                destroy: function t() {
                  ((o = !0), a.destroy(), U(r, el), M(r, t0), B(r, "style", S), B(r, tR, E || ""));
                },
                update: w,
                style: function t(e, i, s) {
                  I((s && C) || r, e, i);
                },
                isWithin: function t(s, n) {
                  var r = te(s - i);
                  return (!k && (p.rewind || e.is(ep)) && (r = Q(r, e.length - r)), r <= n);
                },
              };
              return A;
            })(i, e, n, t);
            (r.mount(),
              C.push(r),
              C.sort(function (t, e) {
                return t.index - e.index;
              }));
          }
          function T(t) {
            return t
              ? P(function (t) {
                  return !t.isClone;
                })
              : C;
          }
          function A(t, e) {
            T(e).forEach(t);
          }
          function P(t) {
            return C.filter(
              c(t)
                ? t
                : function (e) {
                    return h(t) ? k(e.slide, t) : g(f(t), e.index);
                  },
            );
          }
          return {
            mount: function t() {
              (L(), a(tf, _), a(tf, L));
            },
            destroy: _,
            update: function t() {
              A(function (t) {
                t.update();
              });
            },
            register: w,
            get: T,
            getIn: function t(e) {
              var i = n.Controller,
                s = i.toIndex(e),
                o = i.hasFocus() ? 1 : r.perPage;
              return P(function (t) {
                return ts(t.index, s, s + o - 1);
              });
            },
            getAt: function t(e) {
              return P(e)[0];
            },
            add: function t(e, i) {
              (y(e, function (t) {
                if ((h(t) && (t = N(t)), m(t))) {
                  var e,
                    n,
                    o,
                    a,
                    c = p[i];
                  (c ? E(t, c) : S(v, t),
                    $(t, r.classes.slide),
                    (e = t),
                    (n = s(l, tg)),
                    (a = (o = W(e, "img")).length)
                      ? o.forEach(function (t) {
                          d(t, "load error", function () {
                            --a || n();
                          });
                        })
                      : n());
                }
              }),
                l(tf));
            },
            remove: function t(e) {
              (z(
                P(e).map(function (t) {
                  return t.slide;
                }),
              ),
                l(tf));
            },
            forEach: A,
            filter: P,
            style: function t(e, i, s) {
              A(function (t) {
                t.style(e, i, s);
              });
            },
            getLength: function t(e) {
              return e ? p.length : C.length;
            },
            isEnough: function t() {
              return C.length > r.perPage;
            },
          };
        },
        Layout: function t(e, i, n) {
          var r,
            o,
            a,
            d = tL(e),
            c = d.on,
            h = d.bind,
            u = d.emit,
            p = i.Slides,
            m = i.Direction.resolve,
            f = i.Elements,
            y = f.root,
            g = f.track,
            v = f.list,
            $ = p.getAt,
            S = p.style;
          function E() {
            ((r = "ttb" === n.direction),
              I(y, "maxWidth", G(n.width)),
              I(g, m("paddingLeft"), C(!1)),
              I(g, m("paddingRight"), C(!0)),
              k(!0));
          }
          function k(t) {
            var e,
              i = R(y);
            (t || o.width !== i.width || o.height !== i.height) &&
              (I(
                g,
                "height",
                ((e = ""),
                r &&
                  ((e = x()),
                  K(e, "height or heightRatio is missing."),
                  (e = "calc(" + e + " - " + C(!1) + " - " + C(!0) + ")")),
                e),
              ),
              S(m("marginRight"), G(n.gap)),
              S("width", n.autoWidth ? null : G(n.fixedWidth) || (r ? "" : L())),
              S("height", G(n.fixedHeight) || (r ? (n.autoHeight ? null : L()) : x()), !0),
              (o = i),
              u(tv),
              a !== (a = B()) && (b(y, ea, a), u("overflow", a)));
          }
          function C(t) {
            var e = n.padding,
              i = m(t ? "right" : "left");
            return (e && G(e[i] || (l(e) ? 0 : e))) || "0px";
          }
          function x() {
            return G(n.height || R(v).width * n.heightRatio);
          }
          function L() {
            var t = G(n.gap);
            return (
              "calc((100%" + (t && " + " + t) + ")/" + (n.perPage || 1) + (t && " - " + t) + ")"
            );
          }
          function _() {
            return R(v)[m("width")];
          }
          function w(t, e) {
            var i = $(t || 0);
            return i ? R(i.slide)[m("width")] + (e ? 0 : M()) : 0;
          }
          function T(t, e) {
            var i = $(t);
            if (i) {
              var s = R(i.slide)[m("right")],
                n = R(v)[m("left")];
              return te(s - n) + (e ? 0 : M());
            }
            return 0;
          }
          function A(t) {
            return T(e.length - 1) - T(0) + w(0, t);
          }
          function M() {
            var t = $(0);
            return (t && parseFloat(I(t.slide, m("marginRight")))) || 0;
          }
          function B() {
            return e.is(em) || A(!0) > _();
          }
          return {
            mount: function t() {
              var e, i;
              (E(),
                h(
                  window,
                  "resize load",
                  ((e = s(u, tg)),
                  (i = t_(0, e, null, 1)),
                  function () {
                    i.isPaused() && i.start();
                  }),
                ),
                c([ty, tf], E),
                c(tg, k));
            },
            resize: k,
            listSize: _,
            slideSize: w,
            sliderSize: A,
            totalSize: T,
            getPadding: function t(e) {
              return parseFloat(I(g, m("padding" + (e ? "Right" : "Left")))) || 0;
            },
            isOverflow: B,
          };
        },
        Clones: function t(i, s, n) {
          var r,
            o = tL(i),
            a = o.on,
            l = s.Elements,
            d = s.Slides,
            c = s.Direction.resolve,
            h = [];
          function p() {
            (a(tf, m),
              a([ty, tg], y),
              (r = g()) &&
                ((function t(e) {
                  var s = d.get().slice(),
                    r = s.length;
                  if (r) {
                    for (; s.length < e;) v(s, s);
                    v(s.slice(-e), s.slice(0, e)).forEach(function (t, o) {
                      var a,
                        c,
                        u,
                        p = o < e,
                        m =
                          ((a = t.slide),
                          (c = o),
                          (u = a.cloneNode(!0)),
                          $(u, n.classes.clone),
                          (u.id = i.root.id + "-clone" + ta(c + 1)),
                          u);
                      (p ? E(m, s[0].slide) : S(l.list, m),
                        v(h, m),
                        d.register(m, o - e + (p ? 0 : r), t.index));
                    });
                  }
                })(r),
                s.Layout.resize(!0)));
          }
          function m() {
            (f(), p());
          }
          function f() {
            (z(h), e(h), o.destroy());
          }
          function y() {
            var t = g();
            r !== t && (r < t || !t) && o.emit(tf);
          }
          function g() {
            var t = n.clones;
            if (i.is(ep)) {
              if (u(t)) {
                var e = n[c("fixedWidth")] && s.Layout.slideSize(0);
                t =
                  (e && tt(R(l.track)[c("width")] / e)) ||
                  (n[c("autoWidth")] && i.length) ||
                  2 * n.perPage;
              }
            } else t = 0;
            return t;
          }
          return { mount: p, destroy: f };
        },
        Move: function t(e, i, s) {
          var n,
            r = tL(e),
            o = r.on,
            a = r.emit,
            l = e.state.set,
            d = e.state,
            c = i.Layout,
            h = c.slideSize,
            p = c.getPadding,
            m = c.totalSize,
            f = c.listSize,
            y = c.sliderSize,
            g = i.Direction,
            v = g.resolve,
            b = g.orient,
            $ = i.Elements,
            S = $.list,
            E = $.track,
            k = 0;
          function C() {
            return k;
          }
          function x() {
            i.Controller.isBusy() || (i.Scroll.cancel(), L(e.index), i.Slides.update());
          }
          function L(t) {
            _(M(t, !0));
          }
          function _(t, n) {
            if (!e.is(em)) {
              s.paddingCalc &&
                "slide" === s.type &&
                !d.is(6) &&
                (k =
                  t >= -1 * s.padding.right
                    ? 0
                    : y() + t - s.padding.right <= h()
                      ? s.padding.right
                      : s.padding.right / 2);
              var r = n
                ? t
                : (function t(s) {
                    if (e.is(ep)) {
                      var n = A(s),
                        r = n > i.Controller.getEnd();
                      (n < 0 || r) && (s = w(s, r));
                    }
                    return s;
                  })(t);
              (I(S, "transform", `translate${v("X")}(${r + k}px)`), t !== r && a("sh"));
            }
          }
          function w(t, e) {
            var i = t - P(e),
              s = y();
            return t - b(s * (tt(te(i) / s) || 1)) * (e ? 1 : -1);
          }
          function T() {
            (_(B(), !0), n.cancel());
          }
          function A(t) {
            for (var e = i.Slides.get(), s = 0, n = 1 / 0, r = 0; r < e.length; r++) {
              var o = e[r].index,
                a = te(M(o, !0) - t);
              if (a <= n) ((n = a), (s = o));
              else break;
            }
            return s;
          }
          function M(t, i) {
            var n,
              r,
              o,
              a = b(
                m(t - 1) -
                  ((n = t), (r = s.focus), "center" === r ? (f() - h(n, !0)) / 2 : +r * h(n) || 0),
              );
            return i ? ((o = a), s.trimSpace && e.is(eu) && (o = tn(o, 0, b(y(!0) - f()))), o) : a;
          }
          function B() {
            var t = v("left");
            return R(S)[t] - R(E)[t] + b(p(!1)) - k;
          }
          function P(t) {
            return M(t ? i.Controller.getEnd() : 0, !!s.trimSpace);
          }
          return {
            mount: function t() {
              ((n = i.Transition), o([tc, tv, ty, tf], x));
            },
            move: function t(e, i, s, r) {
              var o, d;
              (e !== i &&
                ((o = e > s),
                (d = b(w(B(), o))),
                o ? d >= 0 : d <= S[v("scrollWidth")] - R(E)[v("width")]) &&
                (T(), _(w(B(), e > s), !0)),
                l(4),
                a(tu, i, s, e),
                n.start(i, function () {
                  (l(3), a(tp, i, s, e), r && r());
                }));
            },
            jump: L,
            translate: _,
            shift: w,
            cancel: T,
            toIndex: A,
            toPosition: M,
            getPosition: B,
            getLimit: P,
            exceededLimit: function t(e, i) {
              i = u(i) ? B() : i;
              var s = !0 !== e && b(i) < b(P(!1)),
                n = !1 !== e && b(i) > b(P(!0));
              return s || n;
            },
            reposition: x,
          };
        },
        Controller: function t(e, i, n) {
          var r,
            o,
            a,
            l,
            d = tL(e),
            c = d.on,
            p = d.emit,
            m = i.Move,
            f = m.getPosition,
            y = m.getLimit,
            g = m.toPosition,
            v = i.Slides,
            b = v.isEnough,
            $ = v.getLength,
            S = n.omitEnd,
            E = e.is(ep),
            k = e.is(eu),
            C = s(A, !1),
            x = s(A, !0),
            L = n.start || 0,
            _ = L;
          function w() {
            ((o = $(!0)), (a = n.perMove), (l = n.perPage), (r = P()));
            var t = tn(L, 0, S ? r : o - 1);
            t !== L && ((L = t), m.reposition());
          }
          function T() {
            r !== P() && p("ei");
          }
          function A(t, e) {
            var i,
              s,
              n = a || (H() ? 1 : l),
              o = M(L + n * (t ? -1 : 1), L, !(a || H()));
            if (-1 === o && k) {
              if (((i = f()), !(1 > te(i - (s = y(!t)))))) return t ? 0 : r;
            }
            return e ? o : B(o);
          }
          function M(t, i, s) {
            if (b() || H()) {
              var d = (function t(i) {
                if (k && "move" === n.trimSpace && i !== L)
                  for (var s = f(); s === g(i, !0) && ts(i, 0, e.length - 1, !n.rewind);)
                    i < L ? --i : ++i;
                return i;
              })(t);
              (d !== t && ((i = t), (t = d), (s = !1)),
                t < 0 || t > r
                  ? (t =
                      !a && (ts(0, t, i, !0) || ts(r, i, t, !0))
                        ? I(q(t))
                        : E
                          ? s
                            ? t < 0
                              ? -(o % l || l)
                              : o
                            : t
                          : n.rewind
                            ? t < 0
                              ? r
                              : 0
                            : -1)
                  : s && t !== i && (t = I(q(i) + (t < i ? -1 : 1))));
            } else t = -1;
            return t;
          }
          function B(t) {
            return E ? (t + o) % o || 0 : t;
          }
          function P() {
            for (var t = o - (H() || (E && a) ? 1 : l); S && t-- > 0;)
              if (g(o - 1, !0) !== g(t, !0)) {
                t++;
                break;
              }
            return tn(t, 0, o - 1);
          }
          function I(t) {
            return tn(H() ? t : l * t, 0, r);
          }
          function q(t) {
            return H() ? Q(t, r) : Z((t >= r ? o - 1 : t) / l);
          }
          function D(t) {
            t !== L && ((_ = L), (L = t));
          }
          function H() {
            return !u(n.focus) || n.isNavigation;
          }
          function O() {
            return e.state.is([4, 5]) && !!n.waitForTransition;
          }
          return {
            mount: function t() {
              (w(), c([ty, tf, "ei"], w), c(tv, T));
            },
            go: function t(e, i, s) {
              if (!O()) {
                var n = (function t(e) {
                    var i = L;
                    if (h(e)) {
                      var s = e.match(/([+\-<>])(\d+)?/) || [],
                        n = s[1],
                        o = s[2];
                      "+" === n || "-" === n
                        ? (i = M(L + +("" + n + (+o || 1)), L))
                        : ">" === n
                          ? (i = o ? I(+o) : C(!0))
                          : "<" === n && (i = x(!0));
                    } else i = E ? e : tn(e, 0, r);
                    return i;
                  })(e),
                  o = B(n);
                o > -1 && (i || o !== L) && (D(o), m.move(n, o, _, s));
              }
            },
            scroll: function t(e, s, n, o) {
              i.Scroll.scroll(e, s, n, function () {
                var t = B(m.toIndex(f()));
                (D(S ? Q(t, r) : t), o && o());
              });
            },
            getNext: C,
            getPrev: x,
            getAdjacent: A,
            getEnd: P,
            setIndex: D,
            getIndex: function t(e) {
              return e ? _ : L;
            },
            toIndex: I,
            toPage: q,
            toDest: function t(e) {
              var i = m.toIndex(e);
              return k ? tn(i, 0, r) : i;
            },
            hasFocus: H,
            isBusy: O,
          };
        },
        Arrows: function t(e, i, n) {
          var r,
            o,
            a = tL(e),
            l = a.on,
            d = a.bind,
            c = a.emit,
            h = n.classes,
            u = n.i18n,
            p = i.Elements,
            m = i.Controller,
            f = p.arrows,
            y = p.track,
            g = f,
            v = p.prev,
            b = p.next,
            k = {};
          function C() {
            var t;
            ((t = n.arrows) &&
              !(v && b) &&
              ((g = f || P("div", h.arrows)),
              (v = T(!0)),
              (b = T(!1)),
              (r = !0),
              S(g, [v, b]),
              f || E(g, y)),
              v &&
                b &&
                (w(k, { prev: v, next: b }),
                q(g, t ? "" : "none"),
                $(g, (o = tY + "--" + n.direction)),
                t &&
                  (l([tc, tp, tf, t$, "ei"], A),
                  d(b, "click", s(_, ">")),
                  d(v, "click", s(_, "<")),
                  A(),
                  B([v, b], tD, y.id),
                  c("arrows:mounted", v, b))),
              l(ty, x));
          }
          function x() {
            (L(), C());
          }
          function L() {
            (a.destroy(), U(g, o), r ? (z(f ? [v, b] : g), (v = b = null)) : M([v, b], t0));
          }
          function _(t) {
            m.go(t, !0);
          }
          function T(t) {
            return N(
              '<button class="' +
                h.arrow +
                " " +
                (t ? h.prev : h.next) +
                '" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="' +
                (n.arrowPath ||
                  "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z") +
                '" />',
            );
          }
          function A() {
            if (v && b) {
              var t = e.index,
                i = m.getPrev(),
                s = m.getNext(),
                n = i > -1 && t < i ? u.last : u.prev,
                r = s > -1 && t > s ? u.first : u.next;
              ((v.disabled = i < 0),
                (b.disabled = s < 0),
                B(v, tR, n),
                B(b, tR, r),
                c("arrows:updated", v, b, i, s));
            }
          }
          return { arrows: k, mount: C, destroy: L, update: A };
        },
        Autoplay: function t(e, i, s) {
          var n,
            r,
            o = tL(e),
            a = o.on,
            l = o.bind,
            d = o.emit,
            c = t_(s.interval, e.go.bind(e, ">"), function t(e) {
              var i = u.bar;
              (i && I(i, "width", 100 * e + "%"), d("autoplay:playing", e));
            }),
            h = c.isPaused,
            u = i.Elements,
            p = i.Elements,
            m = p.root,
            f = p.toggle,
            y = s.autoplay,
            g = "pause" === y;
          function v() {
            h() && i.Slides.isEnough() && (c.start(!s.resetProgress), (r = n = g = !1), E(), d(tk));
          }
          function $(t) {
            (void 0 === t && (t = !0), (g = !!t), E(), h() || (c.pause(), d(tC)));
          }
          function S() {
            g || (n || r ? $(!1) : v());
          }
          function E() {
            f && (b(f, ee, !g), B(f, tR, s.i18n[g ? "play" : "pause"]));
          }
          function k(t) {
            var e = i.Slides.getAt(t);
            c.set((e && +H(e.slide, ef)) || s.interval);
          }
          return {
            mount: function t() {
              y &&
                (s.pauseOnHover &&
                  l(m, "mouseenter mouseleave", function (t) {
                    ((n = "mouseenter" === t.type), S());
                  }),
                s.pauseOnFocus &&
                  l(m, "focusin focusout", function (t) {
                    ((r = "focusin" === t.type), S());
                  }),
                f &&
                  l(f, "click", function () {
                    g ? v() : $(!0);
                  }),
                a([tu, tb, tf], c.rewind),
                a(tu, k),
                f && B(f, tD, u.track.id),
                g || v(),
                E());
            },
            destroy: c.cancel,
            play: v,
            pause: $,
            isPaused: h,
          };
        },
        Cover: function t(e, i, n) {
          var r = tL(e).on;
          function o(t) {
            i.Slides.forEach(function (e) {
              var i = x(e.container || e.slide, "img");
              i && i.src && a(t, i, e);
            });
          }
          function a(t, e, i) {
            (i.style("background", t ? 'center/cover no-repeat url("' + e.src + '")' : "", !0),
              q(e, t ? "none" : ""));
          }
          return {
            mount: function t() {
              n.cover && (r(tx, s(a, !0)), r([tc, ty, tf], s(o, !0)));
            },
            destroy: s(o, !1),
          };
        },
        Scroll: function t(e, i, n) {
          var r,
            o,
            a = tL(e),
            l = a.on,
            d = a.emit,
            c = e.state.set,
            h = i.Move,
            u = h.getPosition,
            p = h.getLimit,
            m = h.exceededLimit,
            f = h.translate,
            y = e.is(eu),
            g = 1;
          function v(t, e, n, a, l) {
            var p = u();
            if ((S(), n && (!y || !m()))) {
              var f = i.Layout.sliderSize(),
                v = tr(t) * f * Z(te(t) / f) || 0;
              t = h.toPosition(i.Controller.toDest(t % f)) + v;
            }
            var E,
              k,
              C = ((E = p), (k = t), 1 > te(E - k));
            ((g = 1),
              (e = C ? 0 : e || J(te(t - p) / 1.5, 800)),
              (o = a),
              (r = t_(e, b, s($, p, t, l), 1)),
              c(5),
              d(tb),
              r.start());
          }
          function b() {
            (c(3), o && o(), d(t$));
          }
          function $(t, e, i, s) {
            var r,
              a,
              l = u(),
              d =
                (t +
                  (e - t) * ((r = s), (a = n.easingFunc), a ? a(r) : 1 - Math.pow(1 - r, 4)) -
                  l) *
                g;
            (f(l + d), y && !i && m() && ((g *= 0.6), 10 > te(d) && v(p(m(!0)), 600, !1, o, !0)));
          }
          function S() {
            r && r.cancel();
          }
          function E() {
            r && !r.isPaused() && (S(), b());
          }
          return {
            mount: function t() {
              (l(tu, S), l([ty, tf], E));
            },
            destroy: S,
            scroll: v,
            cancel: E,
          };
        },
        Drag: function t(e, i, s) {
          var n,
            o,
            a,
            d,
            c,
            h,
            u,
            p,
            m = tL(e),
            f = m.on,
            y = m.emit,
            g = m.bind,
            v = m.unbind,
            b = e.state,
            $ = i.Move,
            S = i.Scroll,
            E = i.Controller,
            C = i.Elements.track,
            x = i.Media.reduce,
            L = i.Direction,
            _ = L.resolve,
            w = L.orient,
            T = $.getPosition,
            A = $.exceededLimit,
            M = !1;
          function B() {
            var t,
              e = s.drag;
            ((u = t = !e), (d = "free" === e));
          }
          function P(t) {
            if (((h = !1), !u)) {
              var e,
                i,
                n = V(t);
              ((e = t.target),
                (i = s.noDrag),
                k(e, "." + tQ + ", ." + t6) ||
                  (i && k(e, i)) ||
                  (!n && t.button) ||
                  (E.isBusy()
                    ? F(t, !0)
                    : ((p = n ? C : window),
                      (c = b.is([4, 5])),
                      (a = null),
                      g(p, ec, I, ey),
                      g(p, eh, q, ey),
                      $.cancel(),
                      S.cancel(),
                      H(t))));
            }
          }
          function I(t) {
            if ((b.is(6) || (b.set(6), y("drag")), t.cancelable)) {
              if (c) {
                $.translate(n + ((p = O(t)), p / (M && e.is(eu) ? 5 : 1)));
                var i,
                  r,
                  o,
                  a,
                  d,
                  u,
                  p,
                  m = R(t) > 200,
                  f = M !== (M = A());
                ((m || f) && H(t), (h = !0), y("dragging"), F(t));
              } else {
                ((i = t),
                  te(O(i)) > te(O(i, !0)) &&
                    ((c =
                      ((r = t),
                      (o = s.dragMinThreshold),
                      (a = l(o)),
                      (d = (a && o.mouse) || 0),
                      (u = (a ? o.touch : +o) || 10),
                      te(O(r)) > (V(r) ? u : d))),
                    F(t)));
              }
            }
          }
          function q(t) {
            var n, r, o, a, l;
            (b.is(6) && (b.set(3), y("dragged")),
              c &&
                ((a =
                  ((r = o =
                    (function t(i) {
                      if (e.is(ep) || !M) {
                        var s = R(i);
                        if (s && s < 200) return O(i) / s;
                      }
                      return 0;
                    })((n = t))),
                  T() +
                    tr(r) *
                      Q(
                        te(r) * (s.flickPower || 600),
                        d ? 1 / 0 : i.Layout.listSize() * (s.flickMaxPages || 1),
                      ))),
                (l = s.rewind && s.rewindByDrag),
                x(!1),
                d
                  ? E.scroll(a, 0, s.snap)
                  : e.is(em)
                    ? E.go(0 > w(tr(o)) ? (l ? "<" : "-") : l ? ">" : "+")
                    : e.is(eu) && M && l
                      ? E.go(A(!0) ? ">" : "<")
                      : E.go(E.toDest(a), !0),
                x(!0),
                F(t)),
              v(p, ec, I),
              v(p, eh, q),
              (c = !1));
          }
          function D(t) {
            !u && h && F(t, !0);
          }
          function H(t) {
            ((a = o), (o = t), (n = T()));
          }
          function O(t, e) {
            return N(t, e) - N(z(t), e);
          }
          function R(t) {
            return X(t) - X(z(t));
          }
          function z(t) {
            return (o === t && a) || o;
          }
          function N(t, e) {
            return (V(t) ? t.changedTouches[0] : t)["page" + _(e ? "Y" : "X")];
          }
          function V(t) {
            return "undefined" != typeof TouchEvent && t instanceof TouchEvent;
          }
          function W() {
            return c;
          }
          function U(t) {
            u = t;
          }
          return {
            mount: function t() {
              (g(C, ec, r, ey),
                g(C, eh, r, ey),
                g(C, ed, P, ey),
                g(C, "click", D, { capture: !0 }),
                g(C, "dragstart", F),
                f([tc, ty], B));
            },
            disable: U,
            isDragging: W,
          };
        },
        Keyboard: function t(e, i, s) {
          var r,
            o,
            a = tL(e),
            l = a.on,
            d = a.bind,
            c = a.unbind,
            h = e.root,
            u = i.Direction.resolve;
          function p() {
            var t = s.keyboard;
            t && d((r = "global" === t ? window : h), eb, g);
          }
          function m() {
            c(r, eb);
          }
          function f(t) {
            o = t;
          }
          function y() {
            var t = o;
            ((o = !0),
              n(function () {
                o = t;
              }));
          }
          function g(t) {
            if (!o) {
              var i = ev(t);
              i === u(tw) ? e.go("<") : i === u(tT) && e.go(">");
            }
          }
          return {
            mount: function t() {
              (p(), l(ty, m), l(ty, p), l(tu, y));
            },
            destroy: m,
            disable: f,
          };
        },
        LazyLoad: function t(i, n, r) {
          var o = tL(i),
            a = o.on,
            l = o.off,
            d = o.bind,
            c = o.emit,
            h = "sequential" === r.lazyLoad,
            u = [tp, t$],
            p = [];
          function m() {
            (e(p),
              n.Slides.forEach(function (t) {
                W(t.slide, eE).forEach(function (e) {
                  var i = H(e, e$),
                    s = H(e, eS);
                  if (i !== e.src || s !== e.srcset) {
                    var n = r.classes.spinner,
                      o = e.parentElement,
                      a = x(o, "." + n) || P("span", n, o);
                    (p.push([e, t, a]), e.src || q(e, "none"));
                  }
                });
              }),
              h ? v() : (l(u), a(u, f), f()));
          }
          function f() {
            (p = p.filter(function (t) {
              var e = r.perPage * ((r.preloadPages || 1) + 1) - 1;
              return !t[1].isWithin(i.index, e) || y(t);
            })).length || l(u);
          }
          function y(t) {
            var e = t[0];
            ($(t[1].slide, er),
              d(e, "load error", s(g, t)),
              B(e, "src", H(e, e$)),
              B(e, "srcset", H(e, eS)),
              M(e, e$),
              M(e, eS));
          }
          function g(t, e) {
            var i = t[0],
              s = t[1];
            (U(s.slide, er),
              "error" !== e.type && (z(t[2]), q(i, ""), c(tx, i, s), c(tg)),
              h && v());
          }
          function v() {
            p.length && y(p.shift());
          }
          return {
            mount: function t() {
              r.lazyLoad && (m(), a(tf, m));
            },
            destroy: s(e, p),
            check: f,
          };
        },
        Pagination: function t(n, r, o) {
          var a,
            l,
            d = tL(n),
            c = d.on,
            h = d.emit,
            u = d.bind,
            p = r.Slides,
            m = r.Elements,
            f = r.Controller,
            y = f.hasFocus,
            g = f.getIndex,
            v = f.go,
            b = r.Direction.resolve,
            S = m.pagination,
            E = [];
          function k() {
            (C(), c([ty, tf, "ei"], k));
            var t = o.pagination;
            (S && q(S, t ? "" : "none"),
              t &&
                (c([tu, tb, t$], T),
                (function t() {
                  var e = n.length,
                    i = o.classes,
                    r = o.i18n,
                    d = o.perPage,
                    c = y() ? f.getEnd() + 1 : tt(e / d);
                  ((a = S || P("ul", i.pagination, m.track.parentElement)),
                    $(a, (l = t5 + "--" + _())),
                    B(a, tP, "tablist"),
                    B(a, tR, r.select),
                    B(a, tF, "ttb" === _() ? "vertical" : ""));
                  for (var h = 0; h < c; h++) {
                    var g = P("li", null, a),
                      v = P("button", { class: i.page, type: "button" }, g),
                      b = p.getIn(h).map(function (t) {
                        return t.slide.id;
                      }),
                      k = !y() && d > 1 ? r.pageX : r.slideX;
                    (u(v, "click", s(x, h)),
                      o.paginationKeyboard && u(v, "keydown", s(L, h)),
                      B(g, tP, "presentation"),
                      B(v, tP, "tab"),
                      B(v, tD, b.join(" ")),
                      B(v, tR, to(k, h + 1)),
                      B(v, tI, -1),
                      E.push({ li: g, button: v, page: h }));
                  }
                })(),
                T(),
                h("pagination:mounted", { list: a, items: E }, w(n.index))));
          }
          function C() {
            (a && (z(S ? i(a.children) : a), U(a, l), e(E), (a = null)), d.destroy());
          }
          function x(t) {
            v(">" + t, !0);
          }
          function L(t, e) {
            var i = E.length,
              s = ev(e),
              n = _(),
              r = -1;
            s === b(tT, !1, n)
              ? (r = ++t % i)
              : s === b(tw, !1, n)
                ? (r = (--t + i) % i)
                : "Home" === s
                  ? (r = 0)
                  : "End" === s && (r = i - 1);
            var o = E[r];
            o && (D(o.button), v(">" + r), F(e, !0));
          }
          function _() {
            return o.paginationDirection || o.direction;
          }
          function w(t) {
            return E[f.toPage(t)];
          }
          function T() {
            var t = w(g(!0)),
              e = w(g());
            if (t) {
              var i = t.button;
              (U(i, ee), M(i, tO), B(i, tI, -1));
            }
            if (e) {
              var s = e.button;
              ($(s, ee), B(s, tO, !0), B(s, tI, ""));
            }
            h("pagination:updated", { list: a, items: E }, t, e);
          }
          return { items: E, mount: k, destroy: C, getAt: w, update: T };
        },
        Sync: function t(i, n, r) {
          var o = r.isNavigation,
            a = r.slideFocus,
            l = [];
          function d() {
            var t, e;
            (i.splides.forEach(function (t) {
              t.isParent || (h(i, t.splide), h(t.splide, i));
            }),
              o &&
                ((t = tL(i)),
                (e = t.on),
                e(tm, m),
                e("sk", f),
                e([tc, ty], p),
                l.push(t),
                t.emit(tE, i.splides)));
          }
          function c() {
            (l.forEach(function (t) {
              t.destroy();
            }),
              e(l));
          }
          function h(t, e) {
            var i = tL(t);
            (i.on(tu, function (t, i, s) {
              e.go(e.is(ep) ? s : t);
            }),
              l.push(i));
          }
          function p() {
            B(n.Elements.list, tF, "ttb" === r.direction ? "vertical" : "");
          }
          function m(t) {
            i.go(t.index);
          }
          function f(t, e) {
            g(ek, ev(e)) && (m(t), F(e));
          }
          return {
            setup: s(n.Media.set, { slideFocus: u(a) ? o : a }, !0),
            mount: d,
            destroy: c,
            remount: function t() {
              (c(), d());
            },
          };
        },
        Wheel: function t(e, i, s) {
          var n = tL(e).bind,
            r = 0;
          function o(t) {
            if (t.cancelable) {
              var n,
                o = t.deltaY,
                a = o < 0,
                l = X(t),
                d = s.wheelMinThreshold || 0,
                c = s.wheelSleep || 0;
              (te(o) > d && l - r > c && (e.go(a ? "<" : ">"), (r = l)),
                (n = a),
                (!s.releaseWheel || e.state.is(4) || -1 !== i.Controller.getAdjacent(n)) && F(t));
            }
          }
          return {
            mount: function t() {
              s.wheel && n(i.Elements.track, "wheel", o, ey);
            },
          };
        },
        Live: function t(e, i, n) {
          var r = tL(e).on,
            o = i.Elements.track,
            a = n.live && !n.isNavigation,
            l = P("span", et),
            d = t_(90, s(c, !1));
          function c(t) {
            (B(o, t9, t), t ? (S(o, l), d.start()) : (z(l), d.cancel()));
          }
          function h(t) {
            a && B(o, tW, t ? "off" : "polite");
          }
          return {
            mount: function t() {
              a &&
                (h(!i.Autoplay.isPaused()),
                B(o, tU, !0),
                (l.textContent = "…"),
                r(tk, s(h, !0)),
                r(tC, s(h, !1)),
                r([tp, t$], s(c, !0)));
            },
            disable: h,
            destroy: function t() {
              (M(o, [tW, tU, t9]), z(l));
            },
          };
        },
      }),
      ex = {
        type: "slide",
        role: "region",
        speed: 400,
        perPage: 1,
        cloneStatus: !0,
        arrows: !0,
        pagination: !0,
        paginationKeyboard: !0,
        interval: 5e3,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        resetProgress: !0,
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
        drag: !0,
        direction: "ltr",
        trimSpace: !0,
        focusableNodes: "a, button, textarea, input, select, iframe",
        live: !0,
        classes: {
          slide: tX,
          clone: tG,
          arrows: tY,
          arrow: t6,
          prev: t7,
          next: tK,
          pagination: t5,
          page: tQ,
          spinner: t2 + "spinner",
        },
        i18n: {
          prev: "Previous slide",
          next: "Next slide",
          first: "Go to first slide",
          last: "Go to last slide",
          slideX: "Go to slide %s",
          pageX: "Go to page %s",
          play: "Start autoplay",
          pause: "Pause autoplay",
          carousel: "carousel",
          slide: "slide",
          select: "Select a slide to show",
          slideLabel: "%s of %s",
        },
        reducedMotion: { speed: 0, rewindSpeed: 0, autoplay: "pause" },
      };
    function eL(t, e, i) {
      var s = e.Slides;
      function o() {
        s.forEach(function (t) {
          t.style("transform", "translateX(-" + 100 * t.index + "%)");
        });
      }
      return {
        mount: function e() {
          tL(t).on([tc, tf], o);
        },
        start: function t(e, r) {
          (s.style("transition", "opacity " + i.speed + "ms " + i.easing), n(r));
        },
        cancel: r,
      };
    }
    function e_(t, e, i) {
      var n,
        r = e.Move,
        o = e.Controller,
        a = e.Scroll,
        l = e.Elements.list,
        d = s(I, l, "transition");
      function c() {
        (d(""), a.cancel());
      }
      return {
        mount: function e() {
          tL(t).bind(l, "transitionend", function (t) {
            t.target === l && n && (c(), n());
          });
        },
        start: function e(s, l) {
          var c = r.toPosition(s, !0),
            h = r.getPosition(),
            u = (function e(s) {
              var n = i.rewindSpeed;
              if (t.is(eu) && n) {
                var r = o.getIndex(!0),
                  a = o.getEnd();
                if ((0 === r && s >= a) || (r >= a && 0 === s)) return n;
              }
              return i.speed;
            })(s);
          te(c - h) >= 1 && u >= 1
            ? i.useScroll
              ? a.scroll(c, u, !1, l)
              : (d("transform " + u + "ms " + i.easing), r.translate(c, !0), (n = l))
            : (r.jump(s), l());
        },
        cancel: c,
      };
    }
    var e8 = (function () {
      function t(e, i) {
        ((this.event = tL()),
          (this.Components = {}),
          (this.state = (function t(e) {
            var i = 1;
            function s(t) {
              i = t;
            }
            return {
              set: s,
              is: function t(e) {
                return g(f(e), i);
              },
            };
          })(1)),
          (this.splides = []),
          (this._o = {}),
          (this._E = {}));
        var s = h(e) ? V(document, e) : e;
        (K(s, s + " is invalid."),
          (this.root = s),
          (i = T({ label: H(s, tR) || "", labelledby: H(s, tz) || "" }, ex, t.defaults, i || {})));
        try {
          T(i, JSON.parse(H(s, Y)));
        } catch (n) {
          K(!1, "Invalid JSON");
        }
        this._o = Object.create(T({}, i));
      }
      var s = t.prototype;
      return (
        (s.mount = function t(e, i) {
          var s = this,
            n = this.state,
            r = this.Components;
          (K(n.is([1, 7]), "Already mounted!"),
            n.set(1),
            (this._C = r),
            (this._T = i || this._T || (this.is(em) ? eL : e_)),
            (this._E = e || this._E));
          var o = w({}, eC, this._E, { Transition: this._T });
          return (
            _(o, function (t, e) {
              var i = t(s, r, s._o);
              ((r[e] = i), i.setup && i.setup());
            }),
            _(r, function (t) {
              t.mount && t.mount();
            }),
            this.emit(tc),
            $(this.root, "is-initialized"),
            n.set(3),
            this.emit(th),
            this
          );
        }),
        (s.sync = function t(e) {
          return (
            this.splides.push({ splide: e }),
            e.splides.push({ splide: this, isParent: !0 }),
            this.state.is(3) && (this._C.Sync.remount(), e.Components.Sync.remount()),
            this
          );
        }),
        (s.go = function t(e) {
          return (this._C.Controller.go(e), this);
        }),
        (s.on = function t(e, i) {
          return (this.event.on(e, i), this);
        }),
        (s.off = function t(e) {
          return (this.event.off(e), this);
        }),
        (s.emit = function t(e) {
          var s;
          return ((s = this.event).emit.apply(s, [e].concat(i(arguments, 1))), this);
        }),
        (s.add = function t(e, i) {
          return (this._C.Slides.add(e, i), this);
        }),
        (s.remove = function t(e) {
          return (this._C.Slides.remove(e), this);
        }),
        (s.is = function t(e) {
          return this._o.type === e;
        }),
        (s.refresh = function t() {
          return (this.emit(tf), this);
        }),
        (s.destroy = function t(i) {
          void 0 === i && (i = !0);
          var s = this.event,
            n = this.state;
          return (
            n.is(1)
              ? tL(this).on(th, this.destroy.bind(this, i))
              : (_(
                  this._C,
                  function (t) {
                    t.destroy && t.destroy(i);
                  },
                  !0,
                ),
                s.emit(tS),
                s.destroy(),
                i && e(this.splides),
                n.set(7)),
            this
          );
        }),
        _createClass(t, [
          {
            key: "options",
            get: function t() {
              return this._o;
            },
            set: function t(e) {
              this._C.Media.set(e, !0, !0);
            },
          },
          {
            key: "length",
            get: function t() {
              return this._C.Slides.getLength(!0);
            },
          },
          {
            key: "index",
            get: function t() {
              return this._C.Controller.getIndex();
            },
          },
        ]),
        t
      );
    })();
    return (
      (e8.defaults = {}),
      (e8.STATES = {
        CREATED: 1,
        MOUNTED: 2,
        IDLE: 3,
        MOVING: 4,
        SCROLLING: 5,
        DRAGGING: 6,
        DESTROYED: 7,
      }),
      e8
    );
  }));
class SplideComponent extends HTMLElement {
  constructor() {
    (super(),
      (this.sliderContainer = this.querySelector(".splide")),
      document.addEventListener("shopify:section:load", (t) => {
        this.initSlider();
      }));
  }
  connectedCallback() {
    this.initSlider();
  }
  initSlider() {
    ((this.type = this.dataset.type || "slide"),
      (this.typeMobile = this.dataset.typeMobile || this.type),
      (this.direction = this.dataset.direction || defaultDirection),
      (this.rewind = "fade" === this.type),
      (this.autoplay = "true" === this.dataset.autoplay),
      (this.autoplaySpeed =
        this.dataset.autoplaySpeed && !isNaN(parseInt(this.dataset.autoplaySpeed))
          ? 1e3 * parseInt(this.dataset.autoplaySpeed)
          : 5e3),
      (this.drag = "false" !== this.dataset.drag && ("free" !== this.dataset.drag || "free")),
      (this.focus = this.dataset.focus || 0),
      (this.trimSpace = "false" !== this.dataset.trimSpace),
      (this.arrows = "false" !== this.dataset.arrows),
      (this.arrowsColor = this.dataset.arrowsColor ? ` color-${this.dataset.arrowsColor}` : ""),
      (this.pagination = "false" !== this.dataset.pagination),
      (this.omitEnd = "false" !== this.dataset.omitEnd),
      (this.dotsColor = this.dataset.dotsColor
        ? ` color-${this.dataset.dotsColor} dots-custom-color`
        : ""),
      (this.slidesDesktop =
        this.dataset.slidesDesktop && !isNaN(parseInt(this.dataset.slidesDesktop))
          ? parseInt(this.dataset.slidesDesktop)
          : 3),
      (this.autoWidth = "true" === this.dataset.autoWidth),
      (this.slidesMobile =
        this.dataset.slidesMobile && !isNaN(parseInt(this.dataset.slidesMobile))
          ? parseInt(this.dataset.slidesMobile)
          : 1),
      (this.perMoveDesktop =
        this.dataset.perMoveDesktop && !isNaN(parseInt(this.dataset.perMoveDesktop))
          ? parseInt(this.dataset.perMoveDesktop)
          : 1),
      (this.perMoveMobile =
        this.dataset.perMoveMobile && !isNaN(parseInt(this.dataset.perMoveMobile))
          ? parseInt(this.dataset.perMoveMobile)
          : 1),
      (this.gapDesktop = this.dataset.gapDesktop ? parseInt(this.dataset.gapDesktop) : 30),
      (this.gapMobile = this.dataset.gapMobile ? parseInt(this.dataset.gapMobile) : 15),
      (this.paddingCalcDesktop = "true" === this.dataset.paddingCalcDesktop),
      (this.rightPaddingDesktop = parseInt(this.dataset.sidePaddingDesktop) || 0),
      (this.leftPaddingDesktop = this.dataset.paddingCalcDesktop ? 0 : this.rightPaddingDesktop),
      (this.paddingCalcMobile = "true" === this.dataset.paddingCalcMobile),
      (this.rightPaddingMobile = parseInt(this.dataset.sidePaddingMobile) || 0),
      (this.leftPaddingMobile = this.paddingCalcMobile ? 0 : this.rightPaddingMobile),
      (this.destroyDesktop = "true" === this.dataset.destroyDesktop),
      (this.destroyMobile = "true" === this.dataset.destroyMobile),
      (this.config = {
        type: this.type,
        direction: this.direction,
        rewind: this.rewind,
        autoplay: this.autoplay,
        interval: this.autoplaySpeed,
        drag: this.drag,
        focus: this.focus,
        trimSpace: this.trimSpace,
        arrows: this.arrows,
        pagination: this.pagination,
        omitEnd: this.omitEnd,
        perPage: this.slidesDesktop,
        perMove: this.perMoveDesktop,
        autoWidth: this.autoWidth,
        gap: this.gapDesktop,
        paddingCalc: this.paddingCalcDesktop,
        padding: { left: this.leftPaddingDesktop, right: this.rightPaddingDesktop },
        destroy: this.destroyDesktop,
        classes: {
          arrow: `splide__arrow${this.arrowsColor}`,
          page: `splide__pagination__page${this.dotsColor}`,
        },
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
        breakpoints: {
          749: {
            omitEnd: this.omitEnd,
            type: this.typeMobile,
            perPage: this.slidesMobile,
            perMove: this.perMoveMobile,
            gap: this.gapMobile,
            paddingCalc: this.paddingCalcMobile,
            padding: { left: this.leftPaddingMobile, right: this.rightPaddingMobile },
            destroy: this.destroyMobile,
          },
        },
      }));
    let t = new Splide(this.sliderContainer, this.config);
    (t.on("mounted", () => {
      let e = t.index,
        i = t.Components.Elements.slides[e];
      if (i) {
        let s = i.querySelector("img");
        s
          ? s.complete
            ? (i.classList.add("is-instant-active"), this.setActiveSlideHeight(i))
            : s.addEventListener("load", () => {
                (i.classList.add("is-instant-active"), this.setActiveSlideHeight(i));
              })
          : (i.classList.add("is-instant-active"), this.setActiveSlideHeight(i));
      }
      let n = debounce(() => {
        let e = t.Components.Elements.slides[t.index];
        this.setActiveSlideHeight(e);
      }, 200);
      window.addEventListener("resize", n);
    }),
      t.on("move", (e) => {
        let i = t.index,
          s = t.Components.Elements.slides;
        if (s) {
          let n = s[i];
          n &&
            (s.forEach((t) => t.classList.remove("is-instant-active")),
            n.classList.add("is-instant-active"),
            this.setActiveSlideHeight(n));
        }
      }),
      "true" === this.dataset.pauseVideos &&
        t.on("hidden", (t) => {
          let e = t.slide.querySelector("internal-video");
          if (e) {
            let i = e.dataset.actionOnInactive;
            "pause" === i
              ? (e.video.pause(), e.classList.remove("internal-video--playing"))
              : "mute" === i && ((e.video.muted = !0), e.classList.add("internal-video--muted"));
          }
        }),
      t.mount());
  }
  setActiveSlideHeight(t) {
    if (t) {
      let e = t.offsetHeight;
      this.style.setProperty("--active-slide-height", `${e}px`);
    }
  }
}
customElements.define("splide-component", SplideComponent);
class DetailsDisclosure extends HTMLElement {
  constructor() {
    (super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      (this.content = this.mainDetailsToggle.querySelector("summary").nextElementSibling),
      this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this)));
  }
  onFocusOut() {
    setTimeout(() => {
      this.contains(document.activeElement) || this.close();
    });
  }
  onToggle() {
    (this.animations || (this.animations = this.content.getAnimations()),
      this.mainDetailsToggle.hasAttribute("open")
        ? this.animations.forEach((t) => t.play())
        : this.animations.forEach((t) => t.cancel()));
  }
  close() {
    (this.mainDetailsToggle.removeAttribute("open"),
      this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", !1));
  }
}
customElements.define("details-disclosure", DetailsDisclosure);
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    (super(), (this.header = document.querySelector(".header-wrapper")));
  }
  onToggle() {
    this.header &&
      ((this.header.preventHide = this.mainDetailsToggle.open),
      "" === document.documentElement.style.getPropertyValue("--header-bottom-position-desktop") &&
        document.documentElement.style.setProperty(
          "--header-bottom-position-desktop",
          `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
        ));
  }
}
customElements.define("header-menu", HeaderMenu);
class DetailsModal extends HTMLElement {
  constructor() {
    (super(),
      (this.detailsContainer = this.querySelector("details")),
      (this.summaryToggle = this.querySelector("summary")),
      this.detailsContainer.addEventListener(
        "keyup",
        (t) => "ESCAPE" === t.code.toUpperCase() && this.close(),
      ),
      this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this)),
      this.querySelector('button[type="button"]').addEventListener("click", this.close.bind(this)),
      this.summaryToggle.setAttribute("role", "button"));
  }
  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }
  onSummaryClick(t) {
    (t.preventDefault(),
      t.target.closest("details").hasAttribute("open") ? this.close() : this.open(t));
  }
  onBodyClick(t) {
    (!this.contains(t.target) || t.target.classList.contains("modal-overlay")) && this.close(!1);
  }
  open(t) {
    ((this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)),
      t.target.closest("details").setAttribute("open", !0),
      document.body.addEventListener("click", this.onBodyClickEvent),
      document.body.classList.add("overflow-hidden"),
      "function" == typeof trapFocus &&
        trapFocus(
          this.detailsContainer.querySelector('[tabindex="-1"]'),
          this.detailsContainer.querySelector('input:not([type="hidden"])'),
        ));
  }
  close(t = !0) {
    ("function" == typeof removeTrapFocus && removeTrapFocus(t ? this.summaryToggle : null),
      this.detailsContainer.removeAttribute("open"),
      document.body.removeEventListener("click", this.onBodyClickEvent),
      document.body.classList.remove("overflow-hidden"));
  }
}
customElements.define("details-modal", DetailsModal);
let hotspotButtons = [];
function registerHotspotButton(t) {
  hotspotButtons.push(t);
}
function unregisterHotspotButton(t) {
  let e = hotspotButtons.indexOf(t);
  -1 !== e && hotspotButtons.splice(e, 1);
}
document.addEventListener("mousedown", function (t) {
  for (let e of hotspotButtons) "true" !== e.dataset.open || e.contains(t.target) || e.closeModal();
});
class HotspotButton extends HTMLElement {
  constructor() {
    (super(),
      (this.button = this.querySelector(".hotspot-btn")),
      (this.content = this.querySelector(".hotspot__content")),
      (this.type = this.dataset.type),
      (this.openEvent = this.dataset.openEvent),
      (this.header = document.querySelector(".section-header")),
      (this.stickyHeader = document.querySelector("sticky-header")),
      (this.mobileOverlay = this.querySelector(".hotspot-overlay")),
      this.button.addEventListener("click", this.toggleModal.bind(this)),
      "hover" === this.openEvent &&
        window.matchMedia("(hover: hover)").matches &&
        window.matchMedia("(pointer: fine)").matches &&
        (this.button.addEventListener("mouseover", this.openModal.bind(this)),
        this.button.addEventListener("mouseout", this.startCheckingMouseLeave.bind(this)),
        this.content.addEventListener("mouseover", this.stopCheckingMouseLeave.bind(this)),
        this.content.addEventListener("mouseout", this.startCheckingMouseLeave.bind(this))),
      this.mobileOverlay &&
        this.mobileOverlay.addEventListener("click", this.closeModal.bind(this)));
  }
  startCheckingMouseLeave() {
    ((this.checkingMouseLeave = !0),
      setTimeout(() => {
        this.checkingMouseLeave && this.closeModal();
      }, 200));
  }
  stopCheckingMouseLeave() {
    this.checkingMouseLeave = !1;
  }
  toggleModal() {
    "true" != this.dataset.open && this.openModal();
  }
  openModal() {
    let t = this.header.clientHeight;
    (this.header.classList.contains("shopify-section-header-hidden") || !this.stickyHeader) &&
      (t = 0);
    (this.content.getBoundingClientRect().top - t < 0 && (this.dataset.direction = "bottom"),
      (this.dataset.open = "true"));
  }
  closeModal() {
    ((this.dataset.open = "false"),
      setTimeout(() => {
        this.dataset.direction = "";
      }, 100));
  }
  connectedCallback() {
    registerHotspotButton(this);
  }
  disconnectedCallback() {
    unregisterHotspotButton(this);
  }
}
customElements.define("hotspot-button", HotspotButton);
class ParallaxHero extends HTMLElement {
  constructor() {
    (super(),
      (this.overlays = this.querySelectorAll(".parallax-hero__layer")),
      (this.animateOnEnter = "bottom" === this.dataset.animationStart),
      this.handleScroll(),
      window.addEventListener("scroll", () => requestAnimationFrame(this.handleScroll.bind(this))));
  }
  handleScroll(t) {
    var { top: e, left: i, height: s } = this.getBoundingClientRect();
    let n = window.innerHeight,
      r;
    if (this.animateOnEnter) {
      if (e > n || e + s < 0) return;
      r = Math.min((n - e) / (n + s), 1);
    } else {
      if (e > n || e + s < 0) return;
      let o = e >= 0 ? 0 : -e;
      if (o > s) return;
      r = Math.min(o / s, 1);
    }
    this.overlays.forEach((t) => {
      let i = e * (parseInt(t.dataset.scrollY) / 100),
        s = parseInt(t.dataset.scrollX) * r,
        n = 100 + (parseInt(t.dataset.zoom) - 100) * r,
        o = 3.6 * parseInt(t.dataset.rotation) * r;
      t.style.transform = `translateY(${i}px) translateX(${s}%) scale(${n / 100}) rotate(${o}deg)`;
    });
  }
}
customElements.define("parallax-hero", ParallaxHero);
class ContentTabs extends HTMLElement {
  constructor() {
    (super(),
      (this.activeButtonClass =
        "true" == this.dataset.productTabs ? "active" : "content-tab-button--active"),
      (this.buttons = this.querySelectorAll(".content-tab-button-js")),
      (this.tabs = this.querySelectorAll(".content-tab")),
      (this.tabsContainer = this.querySelector(".content-tabs__tabs-js")),
      (this.activeButton = this.querySelector(`.${this.activeButtonClass}`)),
      (this.activeTab = this.querySelector(".content-tab--active")),
      (this.isMovingAnimation = "moving" === this.dataset.animation),
      this.isMovingAnimation &&
        ((this.activeBg = this.querySelector(".content-tab-buttom__active-bg")),
        this.handleActiveBg(),
        (this.activeBg.style.transitionDuration = "0.4s")),
      this.setHeight(),
      this.buttons.forEach((t) => {
        t.addEventListener("click", this.handleClick.bind(this));
      }),
      window.addEventListener("resize", () => {
        (this.setHeight(), this.isMovingAnimation && this.handleActiveBg());
      }));
  }
  handleClick(t) {
    ((this.activeButton = t.currentTarget),
      this.buttons.forEach((t) => {
        t.classList.remove(this.activeButtonClass);
      }),
      this.activeButton.classList.add(this.activeButtonClass),
      this.tabs.forEach((t) => {
        (t.classList.remove("content-tab--active"),
          t.dataset.index === this.activeButton.dataset.index && (this.activeTab = t));
      }),
      this.activeTab.classList.add("content-tab--active"),
      this.setHeight(),
      this.isMovingAnimation && this.handleActiveBg());
  }
  setHeight() {
    this.activeTab && (this.tabsContainer.style.height = this.activeTab.clientHeight + "px");
  }
  handleActiveBg() {
    ((this.activeBg.style.width = this.activeButton.getBoundingClientRect().width + "px"),
      (this.activeBg.style.height = this.activeButton.getBoundingClientRect().height + "px"),
      (this.activeBg.style.top = this.activeButton.offsetTop + "px"),
      (this.activeBg.style.left = this.activeButton.offsetLeft + "px"));
  }
}
customElements.define("content-tabs", ContentTabs);
class InstaStories extends HTMLElement {
  constructor() {
    (super(),
      (this.openButtons = this.querySelectorAll(".insta-story-open-btn")),
      (this.openButtonsOverflowContainer = this.querySelector(
        ".insta-stories__open-buttons-container",
      )),
      (this.openButtonsContainer = this.querySelector(".insta-stories__open-buttons")),
      (this.openBtnsPrev = this.querySelector(".insta-stories__open-btns-prev")),
      (this.openBtnsNext = this.querySelector(".insta-stories__open-btns-next")),
      (this.closeButtons = this.querySelectorAll(".insta-stories__close-button")),
      (this.modal = this.querySelector(".insta-stories__modal")),
      (this.modalOpen = !1),
      (this.slider = this.querySelector(".insta-stories__slider")),
      (this.stories = this.querySelectorAll(".insta-story")),
      (this.prevBtns = this.querySelectorAll(".insta-story__prev")),
      (this.nextBtns = this.querySelectorAll(".insta-story__next")),
      (this.slideBtns = this.querySelectorAll(".insta-story__slide-btn")),
      (this.activeIndex = 0),
      (this.activeStory = this.stories[this.activeIndex]),
      (this.lastIndex = parseInt(this.dataset.lastIndex)),
      (this.pauseResumeBtns = this.querySelectorAll(".insta-story__pause-resume-btn")),
      (this.isPaused = !1),
      (this.volumeBtns = this.querySelectorAll(".insta-story__volume-btn")),
      (this.isMuted = !0),
      this.initStories(),
      this.initButtonsSlider(),
      this.openButtons.forEach((t) => {
        t.addEventListener("click", this.openModal.bind(this));
      }),
      this.closeButtons.forEach((t) => {
        t.addEventListener("click", this.closeModal.bind(this));
      }),
      this.prevBtns.forEach((t) => {
        t.addEventListener("click", this.storyPrevBtnClick.bind(this));
      }),
      this.nextBtns.forEach((t) => {
        t.addEventListener("click", this.storyNextBtnClick.bind(this));
      }),
      this.slideBtns.forEach((t) => {
        t.addEventListener("click", this.slideBtnClick.bind(this));
      }),
      this.pauseResumeBtns.forEach((t) => {
        t.addEventListener("click", this.togglePauseResume.bind(this));
      }),
      this.volumeBtns.forEach((t) => {
        t.addEventListener("click", this.toggleIsMuted.bind(this));
      }),
      this.slider.addEventListener("touchstart", this.touchStartHandler.bind(this)),
      this.slider.addEventListener("touchend", this.touchEndHandler.bind(this)),
      document.addEventListener("keydown", (t) => {
        if (this.modalOpen)
          switch (t.key) {
            case "Escape":
              this.closeModal();
              break;
            case "ArrowLeft":
              this.storyPrevBtnClick();
              break;
            case "ArrowRight":
              this.storyNextBtnClick();
          }
      }),
      Shopify.designMode &&
        (document.addEventListener("shopify:section:load", () => {
          (this.initStories(), this.initButtonsSlider());
        }),
        document.addEventListener("shopify:section:reorder", () => {
          (this.initStories(), this.initButtonsSlider());
        })));
  }
  autoplay() {
    let t = this.activeStory,
      e = parseInt(t.dataset.activeMediaIndex),
      i = t.querySelectorAll(".insta-story__media")[e],
      s = 1e3 * parseInt(i.getAttribute("data-duration"));
    (this.updateProgressBars(e),
      (this.autoplayStartTime = Date.now()),
      (this.autoplayTimeout = setTimeout(() => {
        this.storyNextBtnClick();
      }, s)));
  }
  storyPrevBtnClick() {
    let t = this.activeStory;
    "0" === t.dataset.activeMediaIndex
      ? this.changeActiveStory(this.activeIndex - 1)
      : this.changeActiveMedia(parseInt(t.dataset.activeMediaIndex) - 1);
  }
  storyNextBtnClick() {
    let t = this.activeStory;
    t.dataset.activeMediaIndex === t.dataset.lastMediaIndex
      ? this.changeActiveStory(this.activeIndex + 1)
      : this.changeActiveMedia(parseInt(t.dataset.activeMediaIndex) + 1);
  }
  slideBtnClick(t) {
    let e = parseInt(t.currentTarget.dataset.index);
    this.changeActiveStory(e);
  }
  changeActiveStory(t) {
    if ((clearTimeout(this.autoplayTimeout), t > this.lastIndex || t < 0)) return;
    let e = this.stories[this.activeIndex];
    e.classList.remove("internal-video--loading");
    let i = parseInt(e.dataset.activeMediaIndex);
    if ("true" === e.dataset.played || i > 0) {
      let s = e.querySelectorAll(".insta-story__progress-item")[i];
      s &&
        (s.classList.remove("insta-story__progress-item--active"),
        t > this.activeIndex && s.classList.add("insta-story__progress-item--completed"));
    }
    let n = e.querySelectorAll(".insta-story__media")[i];
    if (n && "video" === n.getAttribute("data-type")) {
      let r = n.querySelector("video");
      r && (r.pause(), (!this.isPaused || this.bufferPaused) && (r.currentTime = 0));
    }
    ((this.activeIndex = t),
      (this.activeStory = this.stories[this.activeIndex]),
      this.stories.forEach((t) => {
        t.classList.remove("insta-story--active");
      }),
      this.activeStory.classList.add("insta-story--active"),
      this.activeStory.classList.remove("internal-video--loading"),
      (this.activeStory.dataset.played = "true"),
      (this.slider.style.transform = `translateX(calc(var(--story-width) * ${this.activeIndex * (isRtl ? 1 : -1)}))`));
    let o = parseInt(this.activeStory.dataset.activeMediaIndex, 10);
    (this.changeActiveMedia(o), this.updateProgressBars(o));
  }
  changeActiveMedia(t) {
    if (
      (this.bufferPaused && this.isPaused && this.resumeStory(),
      clearTimeout(this.autoplayTimeout),
      t < 0)
    )
      return;
    let e = this.activeStory,
      i = parseInt(e.dataset.lastMediaIndex);
    if (t > i) return;
    (this.currentVideoEl &&
      (this.currentVideoEl.removeEventListener("waiting", this._onBuffer),
      this.currentVideoEl.removeEventListener("playing", this._onResume),
      (this.currentVideoEl = null)),
      (e.dataset.activeMediaIndex = t));
    let s = e.querySelectorAll(".insta-story__media");
    for (let n = 0; n < s.length; n++) {
      let r = s[n],
        o = r.querySelector("video");
      n === t
        ? ((r.style.display = "block"),
          "video" === r.getAttribute("data-type") &&
            o &&
            (this.isPaused || o.play(),
            (this._onBuffer = () => {
              (this.isPaused || this.pauseStory(!0),
                (this.bufferPaused = !0),
                e.classList.add("internal-video--loading"));
            }),
            (this._onResume = () => {
              (this.isPaused && this.resumeStory(),
                (this.bufferPaused = !1),
                e.classList.remove("internal-video--loading"));
            }),
            o.addEventListener("waiting", this._onBuffer),
            o.addEventListener("playing", this._onResume),
            (this.currentVideoEl = o)),
          (e.querySelector(".insta-story__time-posted").innerHTML = r.dataset.timePosted))
        : ((r.style.display = ""),
          "video" === r.getAttribute("data-type") &&
            o &&
            (o.pause(), (!this.isPaused || this.bufferPaused) && (o.currentTime = 0)));
    }
    (this.updateProgressBars(t), this.isPaused || this.autoplay());
    let a = e.querySelectorAll(".insta-story__prev"),
      l = e.querySelectorAll(".insta-story__next");
    (a.forEach((e) => {
      e.toggleAttribute("disabled", 0 === this.activeIndex && 0 === t);
    }),
      l.forEach((e) => {
        e.toggleAttribute("disabled", this.activeIndex === this.lastIndex && t === i);
      }));
  }
  updateProgressBars(t) {
    let e = this.activeStory,
      i = e.querySelectorAll(".insta-story__progress-item");
    i.forEach((e, i) => {
      (e.classList.remove(
        "insta-story__progress-item--completed",
        "insta-story__progress-item--active",
      ),
        i < t
          ? e.classList.add("insta-story__progress-item--completed")
          : i === t && e.classList.add("insta-story__progress-item--active"));
    });
  }
  openModal(t) {
    (window.scrollBy(0, -1),
      (this.modal.dataset.open = "true"),
      (this.modalOpen = !0),
      document.body.classList.add("overflow-hidden"),
      this.changeActiveStory(parseInt(t.currentTarget.dataset.index)));
  }
  closeModal(t) {
    (this.querySelectorAll("video").forEach((t) => {
      t.pause();
    }),
      (this.modal.dataset.open = "false"),
      (this.modalOpen = !1),
      document.body.classList.remove("overflow-hidden"),
      clearTimeout(this.autoplayTimeout));
  }
  initButtonsSlider() {
    if (this.openButtonsOverflowContainer.clientWidth > this.openButtonsContainer.clientWidth)
      return;
    let t = () => "ontouchstart" in window || navigator.maxTouchPoints,
      e,
      i = 0,
      s = 0,
      n = (t) => {
        ((this.openButtonsContainer.style.transform = `translateX(${t}px)`), (i = t));
      };
    (this.openButtonsOverflowContainer.addEventListener("touchstart", (t) => {
      ((this.isDragging = !0), (e = t.touches[0].clientX - s));
    }),
      this.openButtonsOverflowContainer.addEventListener("touchmove", (t) => {
        if (!this.isDragging) return;
        let i = t.touches[0].clientX,
          s = i - e;
        s < 0 &&
          Math.abs(s) <=
            this.openButtonsContainer.offsetWidth - this.openButtonsOverflowContainer.offsetWidth &&
          n(s);
      }),
      this.openButtonsOverflowContainer.addEventListener("touchend", () => {
        ((this.isDragging = !1), (s = i));
      }));
    let r = parseFloat(getComputedStyle(this.openButtons[0]).width),
      o = parseFloat(getComputedStyle(this.openButtonsContainer).columnGap),
      a = () => {
        let t = Math.floor(this.openButtonsOverflowContainer.clientWidth / (r + o));
        return (t - 1) * (r + o);
      },
      l = isRtl ? -1 : 1,
      d = () => {
        let t = this.openButtonsOverflowContainer.scrollLeft * l;
        ((this.openBtnsPrev.style.display = t <= 0 ? "none" : "grid"),
          (this.openBtnsNext.style.display =
            t >
            this.openButtonsOverflowContainer.scrollWidth - this.openButtonsContainer.clientWidth
              ? "none"
              : "grid"));
      };
    (this.openBtnsPrev.addEventListener("click", () => {
      (this.openButtonsOverflowContainer.scrollBy({ left: -a() * l, behavior: "smooth" }),
        setTimeout(d, 300));
    }),
      this.openBtnsNext.addEventListener("click", () => {
        (this.openButtonsOverflowContainer.scrollBy({ left: a() * l, behavior: "smooth" }),
          setTimeout(d, 300));
      }),
      d(),
      t() &&
        ((this.openBtnsPrev.style.display = "none"), (this.openBtnsNext.style.display = "none")),
      window.addEventListener(
        "resize",
        debounce(() => {
          this.openButtonsOverflowContainer.clientWidth <= this.openButtonsContainer.clientWidth
            ? t()
              ? ((this.openBtnsPrev.style.display = "none"),
                (this.openBtnsNext.style.display = "none"))
              : d()
            : ((this.openBtnsPrev.style.display = "none"),
              (this.openBtnsNext.style.display = "none"));
        }, 250),
      ));
  }
  initStories() {
    this.stories.forEach((t) => {
      let e = t.querySelectorAll(".insta-story__media");
      ((t.dataset.lastMediaIndex = e.length - 1), (t.dataset.played = "false"));
      let i = t.querySelector(".insta-story__progress");
      for (let s = 0; s < e.length; s++) {
        let n = e[s].getAttribute("data-duration"),
          r = document.createElement("span");
        ((r.className = "insta-story__progress-item"), r.style.setProperty("--duration", `${n}s`));
        let o = document.createElement("span");
        ((o.className = "insta-story__progress-bar"), r.appendChild(o), i.appendChild(r));
      }
      let a = parseInt(t.dataset.activeMediaIndex);
      e[a] && (e[a].style.display = "block");
    });
  }
  togglePauseResume(t) {
    let e = "true" === t.currentTarget.getAttribute("data-paused");
    (e ? this.resumeStory() : this.pauseStory(),
      this.pauseResumeBtns.forEach((t) => {
        t.setAttribute("data-paused", e ? "false" : "true");
      }));
  }
  pauseStory(t = !1) {
    this.isPaused = !0;
    let e =
        this.activeStory.querySelectorAll(".insta-story__media")[
          parseInt(this.activeStory.dataset.activeMediaIndex)
        ],
      i = 1e3 * parseInt(e.getAttribute("data-duration"));
    if (
      ((this.remainingTime = i - (Date.now() - this.autoplayStartTime)),
      clearTimeout(this.autoplayTimeout),
      "video" === e.getAttribute("data-type") && !t)
    ) {
      let s = e.querySelector("video");
      s && s.pause();
    }
    let n = this.querySelectorAll(".insta-story__progress-bar");
    n.forEach((t) => {
      t.style.animationPlayState = "paused";
    });
  }
  resumeStory() {
    this.isPaused = !1;
    let t = this.querySelectorAll(".insta-story__progress-bar");
    t.forEach((t) => {
      t.style.animationPlayState = "running";
    });
    let e =
      this.activeStory.querySelectorAll(".insta-story__media")[
        parseInt(this.activeStory.dataset.activeMediaIndex)
      ];
    if ("video" === e.getAttribute("data-type")) {
      let i = e.querySelector("video");
      i && i.play();
    }
    ((this.autoplayStartTime = Date.now()),
      (this.autoplayTimeout = setTimeout(() => {
        this.storyNextBtnClick();
      }, this.remainingTime)));
  }
  toggleIsMuted(t) {
    (t.currentTarget, (this.isMuted = !this.isMuted));
    let e = this.querySelectorAll("video");
    (e.forEach((t) => {
      t.muted = this.isMuted;
    }),
      this.volumeBtns.forEach((t) => {
        this.isMuted ? t.setAttribute("data-muted", "true") : t.setAttribute("data-muted", "false");
      }));
  }
  touchStartHandler(t) {
    this.touchStartX = t.touches[0].clientX;
  }
  touchEndHandler(t) {
    let e = t.changedTouches[0].clientX,
      i = e - this.touchStartX;
    if (50 > Math.abs(i)) return;
    let s = isRtl ? -1 : 1;
    i < 0
      ? this.activeIndex < this.lastIndex && this.changeActiveStory(this.activeIndex + s)
      : this.activeIndex > 0 && this.changeActiveStory(this.activeIndex - s);
  }
}
customElements.define("insta-stories", InstaStories);
class TncCheckbox extends HTMLElement {
  constructor() {
    (super(), (this.checked = !1));
    let t = this.dataset.target || "#CartDrawer-Checkout";
    if (
      ((this.checkoutButton =
        document.querySelector(t) ||
        this.closest("form")?.querySelector('button[type="submit"], .button')),
      (this.disableButton = "true" === this.dataset.disableButton),
      (this.warningText = this.dataset.warningText),
      (this.warningTextElement = document.querySelector(
        `.tnc-checkbox-warning--${this.dataset.warningPosition}-${this.dataset.section}`,
      )),
      !this.checkoutButton || !this.warningTextElement)
    )
      return;
    (this.warningTextElement && (this.warningTextElement.innerHTML = this.warningText),
      this.disableButton && this.checkoutButton.classList.add("disabled"),
      this.addEventListener("click", this.handleCheckboxClick.bind(this)),
      this.checkoutButton.addEventListener("click", this.handleButtonClick.bind(this)));
  }
  handleCheckboxClick() {
    ((this.checked = !this.checked),
      (this.dataset.checked = this.checked),
      this.checked
        ? (this.warningTextElement.classList.add("hidden"),
          this.disableButton && this.checkoutButton.classList.remove("disabled"))
        : this.disableButton && this.checkoutButton.classList.add("disabled"));
  }
  handleButtonClick(t) {
    !0 !== this.checked && (t.preventDefault(), this.warningTextElement.classList.remove("hidden"));
  }
}
customElements.define("tnc-chekcbox", TncCheckbox);
class ContactForm extends HTMLElement {
  constructor() {
    (super(),
      (this.handleFormSubmit = this.handleFormSubmit.bind(this)),
      (this.handleFieldInput = this.handleFieldInput.bind(this)),
      (this.button = this.querySelector(".button")),
      (this.tnc = this.querySelector(".tnc-checkbox")));
  }
  connectedCallback() {
    ((this.form = this.querySelector("form")),
      this.form &&
        ((this.requiredFields = Array.from(
          this.querySelectorAll('.field-wrapper[data-required="true"]'),
        )),
        this.requiredFields.length > 0 &&
          (this.form.addEventListener("submit", this.handleFormSubmit),
          this.requiredFields.forEach((t) => {
            let e = t.querySelector(".field__input, .text-area, .select__select");
            e && e.addEventListener("input", this.handleFieldInput);
          }))));
  }
  disconnectedCallback() {
    (this.form && this.form.removeEventListener("submit", this.handleFormSubmit),
      this.requiredFields.forEach((t) => {
        let e = t.querySelector(".field__input, .text-area, .select__select");
        e && e.removeEventListener("input", this.handleFieldInput);
      }));
  }
  handleFormSubmit(t) {
    this.button && ((this.button.disabled = !0), this.button.classList.add("loading"));
    let e = !0;
    if (this.tnc && "true" !== this.tnc.dataset.checked) {
      e = !1;
      let i = document.querySelector(
        `.tnc-checkbox-warning--${tnc.dataset.warningPosition}-${tnc.dataset.section}`,
      );
      i && i.classList.remove("hidden");
    }
    if (
      (this.requiredFields.forEach((t) => {
        let i = t.querySelector(".field__input, .text-area, .select__select"),
          s = t.querySelector(".field-wrapper__error-msg");
        i &&
          !i.value.trim() &&
          ((e = !1), t.classList.add("field-wrapper--error"), s && s.classList.remove("hidden"));
      }),
      !e)
    )
      return (
        this.button && ((this.button.disabled = !1), this.button.classList.remove("loading")),
        t.preventDefault(),
        t.stopImmediatePropagation(),
        !1
      );
  }
  handleFieldInput(t) {
    let e = t.target,
      i = e.closest(".field-wrapper"),
      s = i.querySelector(".field-wrapper__error-msg");
    (i.classList.remove("field-wrapper--error"), s && s.classList.add("hidden"));
  }
}
customElements.define("contact-form", ContactForm);
class PopupCopyButton extends CopyButton {
  constructor() {
    (super(), (this.copySuccessMsg = document.querySelector(".popup-modal__success-msg")));
  }
  handleClick(t) {
    (this.textarea.select(),
      document.execCommand("copy"),
      (this.copySuccessMsg.style.display = "block"));
  }
}
customElements.define("popup-copy-button", PopupCopyButton);
class PageScrollProgress extends HTMLElement {
  connectedCallback() {
    ((this.track = this.querySelector(".page-progress__track")),
      (this.fill = this.querySelector(".page-progress__fill")),
      (this.update = this.update.bind(this)),
      window.addEventListener("scroll", this.update),
      window.addEventListener("resize", this.update),
      this.update());
  }
  update() {
    let t = document.documentElement,
      e = window.pageYOffset || t.scrollTop,
      i = t.scrollHeight - t.clientHeight;
    this.fill.style.width = (i > 0 ? Math.round((e / i) * 100) : 0) + "%";
  }
}
customElements.define("page-scroll-progress", PageScrollProgress);
class DateCountdownTimer extends HTMLElement {
  connectedCallback() {
    if (
      ((this.update = this.update.bind(this)),
      (this.wrapper = this.closest(".countdown-wrapper")),
      !this.wrapper)
    )
      return;
    let t = (this.wrapper.dataset.endTime || "").trim(),
      e = this.wrapper.dataset.timezone,
      i = parseInt(this.wrapper.dataset.utcOffset) || 0;
    if (
      ((this.behavior = this.wrapper.dataset.endBehavior),
      (this.repeatHours = parseInt(this.wrapper.dataset.repeatHours) || 24),
      (this.labels = {
        days: this.wrapper.dataset.labelDays,
        hours: this.wrapper.dataset.labelHours,
        minutes: this.wrapper.dataset.labelMinutes,
        seconds: this.wrapper.dataset.labelSeconds,
      }),
      (this.units = {
        days: "true" === this.wrapper.dataset.showDays,
        hours: "true" === this.wrapper.dataset.showHours,
        minutes: "true" === this.wrapper.dataset.showMinutes,
        seconds: "true" === this.wrapper.dataset.showSeconds,
      }),
      (this.timerStyle = this.dataset.style),
      (this.endTime = this.parseEndTime(t, e, i)),
      !(this.endTime instanceof Date) || isNaN(this.endTime.getTime()))
    ) {
      this.wrapper.style.display = "none";
      return;
    }
    ((this.timer = setInterval(this.update, 1e3)), this.update());
  }
  parseEndTime(t, e, i) {
    let s = t.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/);
    if (!s) {
      let n = new Date(t.replace(/-/g, "/"));
      return n;
    }
    let r = parseInt(s[1], 10),
      o = parseInt(s[2], 10) - 1,
      a = parseInt(s[3], 10),
      l = parseInt(s[4], 10),
      d = parseInt(s[5], 10),
      c = parseInt(s[6] || "0", 10);
    if ("fixed" !== e) return new Date(r, o, a, l, d, c);
    {
      let h = Date.UTC(r, o, a, l, d, c) - 36e5 * i;
      return new Date(h);
    }
  }
  update() {
    let t = new Date(),
      e = Math.floor((this.endTime - t) / 1e3);
    if (!isFinite(e)) return;
    if (e <= 0) {
      if ("hide" === this.behavior) {
        ((this.wrapper.style.display = "none"), clearInterval(this.timer));
        return;
      }
      if ("restart" === this.behavior) {
        let i = new Date(this.endTime),
          s = 36e5 * this.repeatHours;
        for (; i <= t;) i = new Date(i.getTime() + s);
        ((this.endTime = i), (e = Math.floor((this.endTime - t) / 1e3)));
      } else if ("next_day" === this.behavior) {
        let n = new Date(this.endTime);
        for (; n <= t;) n.setDate(n.getDate() + 1);
        ((this.endTime = n), (e = Math.floor((this.endTime - t) / 1e3)));
      }
    }
    let r = Math.floor(e / 86400),
      o = Math.floor((e % 86400) / 3600),
      a = Math.floor((e % 3600) / 60),
      l = e % 60,
      d = { days: r, hours: o, minutes: a, seconds: l };
    Object.keys(this.units).forEach((t) => {
      if (!this.units[t]) return;
      let e = this.querySelector(
        `[aria-label="${"days" === t ? "Day" : "hours" === t ? "Hour" : "minutes" === t ? "Minute" : "Second"}"]`,
      );
      if (!e) return;
      let i = e.querySelector(".countdown-timer__number");
      if (!i) return;
      let s = String(d[t]).padStart(2, "0");
      ("4" === this.timerStyle
        ? ((i.innerHTML = ""),
          s.split("").forEach((t) => {
            let e = document.createElement("span");
            ((e.className = "countdown-timer__digit"), (e.textContent = t), i.appendChild(e));
          }))
        : (i.textContent = s),
        i.setAttribute("aria-label", `${d[t]} ${this.labels[t]}`));
    });
  }
  disconnectedCallback() {
    clearInterval(this.timer);
  }
}
customElements.define("date-countdown-timer", DateCountdownTimer);
class LocalizationForm extends HTMLElement {
  constructor() {
    (super(),
      (this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector("button"),
        panel: this.querySelector(".disclosure__list-wrapper"),
      }),
      this.elements.button.addEventListener("click", this.openSelector.bind(this)),
      this.addEventListener("keyup", this.onContainerKeyUp.bind(this)),
      this.querySelectorAll("a").forEach((t) =>
        t.addEventListener("click", this.onItemClick.bind(this)),
      ),
      document.addEventListener("click", this.handleClickOutside.bind(this)));
  }
  hidePanel() {
    (this.elements.button.setAttribute("aria-expanded", "false"),
      this.elements.panel.setAttribute("hidden", !0));
  }
  onContainerKeyUp(t) {
    "ESCAPE" === t.code.toUpperCase() && (this.hidePanel(), this.elements.button.focus());
  }
  onItemClick(t) {
    t.preventDefault();
    let e = this.querySelector("form");
    ((this.elements.input.value = t.currentTarget.dataset.value), e && e.submit());
  }
  openSelector() {
    (this.elements.button.focus(),
      this.elements.panel.toggleAttribute("hidden"),
      this.elements.button.setAttribute(
        "aria-expanded",
        ("false" === this.elements.button.getAttribute("aria-expanded")).toString(),
      ));
  }
  handleClickOutside(t) {
    this.contains(t.target) || this.hidePanel();
  }
}
customElements.define("localization-form", LocalizationForm);
class ResultsContainer extends HTMLElement {
  constructor() {
    (super(),
      (this.styleType = this.dataset.style),
      (this.duration = parseInt(this.dataset.duration, 10) || 650),
      (this.initDelay = parseInt(this.dataset.delay, 10) || 0),
      (this.observer = new IntersectionObserver(
        (t) => {
          t.forEach((t) => {
            t.isIntersecting &&
              (setTimeout(() => this.animateAll(), this.initDelay), this.observer.disconnect());
          });
        },
        { threshold: 0.3 },
      )));
  }
  connectedCallback() {
    this.observer.observe(this);
  }
  animateAll() {
    let t = this.querySelectorAll(".results__percentage");
    t.forEach((t) => {
      let e = parseInt(t.dataset.percentage, 10) || 0;
      this.animateRow(t, e);
    });
  }
  animateRow(t, e) {
    let i = t.querySelector("p"),
      s = performance.now();
    if ("circle" === this.styleType) {
      let n = t.querySelector(".ring__prog");
      n &&
        requestAnimationFrame(() => {
          n.setAttribute("stroke-dasharray", `${e} 100`);
        });
    }
    let r = (t) => {
      let n = Math.min((t - s) / this.duration, 1);
      (i && (i.textContent = `${Math.round(n * e)}%`), n < 1 && requestAnimationFrame(r));
    };
    requestAnimationFrame(r);
  }
}
customElements.define("results-container", ResultsContainer);
class HdlTimeline extends HTMLElement {
  connectedCallback() {
    if (
      ((this.direction = this.dataset.direction || "vertical"),
      (this.styleVertical = this.dataset.styleVertical || "classic"),
      (this.styleHorizontal = this.dataset.styleHorizontal || "classic"),
      (this.animateVertical = "true" === this.dataset.animateVertical),
      (this.animateHorizontal = "true" === this.dataset.animateHorizontal),
      (this.pointAnimMs =
        1e3 * Math.max(0, parseFloat(this.dataset.pointAnimationDuration || "0"))),
      (this.lineAnimMs = 1e3 * Math.max(0, parseFloat(this.dataset.lineAnimationDuration || "0"))),
      (this.stepDelayMs = this.pointAnimMs + this.lineAnimMs),
      (this.timelineRoot = this.querySelector(".timeline") || this),
      (this.itemsContainer = this.querySelector(".timeline__items")),
      (this.items = Array.from(this.querySelectorAll(".timeline__item"))),
      (this.activeContentOutlet = this.querySelector("[data-active-outlet]")),
      (this.sliderComponent = this.querySelector("timeline-slider")),
      this.itemsContainer && 0 !== this.items.length)
    ) {
      if (
        (this.items.forEach((t, e) => (t.dataset.index = String(e))),
        (this.activeIndex = 0),
        (this.dataset.mode =
          "vertical" === this.direction ? this.styleVertical : this.styleHorizontal),
        (this._suppressScroll = !1),
        (this._restoreTimer = null),
        (this.activeTransitionMs =
          1e3 * Math.max(0, parseFloat(this.dataset.activeTransitionDuration || "0.25"))),
        (this._activeContentTimer = null),
        "vertical" === this.direction)
      ) {
        this.alignMarkersToHeaders();
        let t = debounce(() => {
          this.alignMarkersToHeaders();
        }, 200);
        (window.addEventListener("resize", t), this.initVertical());
      } else "horizontal" === this.direction && this.initHorizontal();
    }
  }
  initVertical() {
    switch (this.styleVertical) {
      case "classic":
        this.initClassicMode(this.animateVertical);
        break;
      case "scroll_activated":
        this.initVerticalScrollActivated();
        break;
      case "accordion":
        this.initVerticalAccordion();
    }
  }
  initHorizontal() {
    switch ((console.log("init"), this.styleHorizontal)) {
      case "classic":
        this.initClassicMode(this.animateHorizontal);
        break;
      case "slider_click":
        this.initHorizontalSliderClick();
    }
  }
  setActiveUpTo(t) {
    (this.items.forEach((e, i) => {
      i <= t ? e.classList.add("is-active") : e.classList.remove("is-active");
    }),
      (this.activeIndex = t));
  }
  setOnlyOpen(t) {
    this.items.forEach((e, i) => {
      e.classList.toggle("is-open", i === t);
    });
  }
  updateActiveContentFrom(t) {
    if (!this.activeContentOutlet) return;
    let e = this.activeContentOutlet,
      i = this.items[t];
    if (!i) return;
    let s = i.querySelector(".timeline-item__active");
    if (!s) return;
    let n = s.innerHTML,
      r = e.querySelector(".timeline-active-content__inner");
    r ||
      (((r = document.createElement("div")).className = "timeline-active-content__inner"),
      (r.innerHTML = e.innerHTML),
      (e.innerHTML = ""),
      e.appendChild(r));
    let o = e.offsetHeight;
    e.style.height = `${o}px`;
    let a = e.style.transition;
    ((e.style.transition = "none"),
      (e.style.opacity = "0"),
      e.offsetHeight,
      (r.innerHTML = n),
      (e.style.height = "auto"));
    let l = e.offsetHeight;
    ((e.style.height = `${o}px`),
      e.offsetHeight,
      (e.style.transition = a || ""),
      requestAnimationFrame(() => {
        ((e.style.height = `${l}px`), (e.style.opacity = "1"));
      }));
    let d = (t) => {
      "height" === t.propertyName &&
        ((e.style.height = ""), e.removeEventListener("transitionend", d));
    };
    e.addEventListener("transitionend", d);
  }
  whenSectionEntersViewport(t) {
    let e = new IntersectionObserver(
      (i) => {
        for (let s of i)
          if (s.isIntersecting) {
            (e.disconnect(), t());
            break;
          }
      },
      { root: null, threshold: 0.15 },
    );
    e.observe(this);
  }
  computeIndexClosestToViewportCenter() {
    let t = window.innerHeight / 2,
      e = 0,
      i = 1 / 0;
    for (let s = 0; s < this.items.length; s++) {
      let n = this.items[s].getBoundingClientRect(),
        r = n.top + n.height / 2,
        o = Math.abs(r - t);
      o < i && ((i = o), (e = s));
    }
    return e;
  }
  attachScrollListener(t) {
    let e = !1,
      i = () => {
        e ||
          ((e = !0),
          requestAnimationFrame(() => {
            (t(), (e = !1));
          }));
      };
    return (
      window.addEventListener("scroll", i, { passive: !0 }),
      () => window.removeEventListener("scroll", i)
    );
  }
  computeCompressionFactor(t, e) {
    let i = Math.abs(Number(t) - Number(e));
    return Math.max(1, i);
  }
  withCompressedDurationsToFinishTogether(t, e, i) {
    let s = this.computeCompressionFactor(t, e);
    if (
      (this._restoreTimer && (clearTimeout(this._restoreTimer), (this._restoreTimer = null)),
      !this.timelineRoot || s <= 1)
    )
      return (i?.(), 0);
    let n = this.pointAnimMs / s / 1e3,
      r = this.lineAnimMs / s / 1e3,
      o = this.timelineRoot.style.getPropertyValue("--point-animation-duration"),
      a = this.timelineRoot.style.getPropertyValue("--line-animation-duration");
    (this.timelineRoot.style.setProperty("--point-animation-duration", `${n}s`),
      this.timelineRoot.style.setProperty("--line-animation-duration", `${r}s`),
      i?.());
    let l = this.pointAnimMs + this.lineAnimMs;
    return (
      (this._restoreTimer = window.setTimeout(() => {
        (o
          ? this.timelineRoot.style.setProperty("--point-animation-duration", o.trim())
          : this.timelineRoot.style.removeProperty("--point-animation-duration"),
          a
            ? this.timelineRoot.style.setProperty("--line-animation-duration", a.trim())
            : this.timelineRoot.style.removeProperty("--line-animation-duration"),
          (this._restoreTimer = null));
      }, l)),
      l
    );
  }
  smoothScrollItemToViewportCenter(t) {
    let e = this.items[t];
    if (!e) return 0;
    let i = e.getBoundingClientRect(),
      s = i.top + i.height / 2,
      n = window.innerHeight / 2,
      r = s - n;
    if (2 > Math.abs(r)) return 0;
    let o = window.scrollY + r;
    return (
      window.scrollTo({ top: o, behavior: "smooth" }),
      Math.min(900, Math.max(200, Math.abs(r) / 1.2))
    );
  }
  activateItem(t, e = {}) {
    let { scrollIntoView: i = !1 } = e;
    i && (this._suppressScroll = !0);
    let s = this.activeIndex ?? 0,
      n = this.withCompressedDurationsToFinishTogether(t, s, () => {
        (this.setOnlyOpen(t), this.setActiveUpTo(t), this.updateActiveContentFrom(t));
      }),
      r = 0;
    if ((i && (r = this.smoothScrollItemToViewportCenter(t)), i)) {
      let o = Math.max(n, r) + 50;
      window.setTimeout(() => {
        this._suppressScroll = !1;
      }, o);
    }
  }
  attachItemClickActivation(t) {
    this.items.forEach((e, i) => {
      e.addEventListener("click", (e) => {
        (console.log("a"),
          !e.target.closest("a, input, select, textarea, [data-stop-activation]") &&
            (this.activateItem(i, { scrollIntoView: t }),
            this.sliderComponent && this.sliderComponent.setCurrentIndexFromTimeline(i)));
      });
    });
  }
  initClassicMode(t) {
    t &&
      this.whenSectionEntersViewport(() => {
        this.items.forEach((t, e) => {
          setTimeout(() => t.classList.add("is-active"), this.stepDelayMs * e);
        });
      });
  }
  initVerticalScrollActivated() {
    this.whenSectionEntersViewport(() => {
      (this.setActiveUpTo(0), this.setOnlyOpen(0), this.updateActiveContentFrom(0));
      let t = () => {
        if (this._suppressScroll) return;
        let t = this.computeIndexClosestToViewportCenter();
        t !== this.activeIndex &&
          (this.setActiveUpTo(t), this.setOnlyOpen(t), this.updateActiveContentFrom(t));
      };
      (t(), (this.detachScroll = this.attachScrollListener(t)), this.attachItemClickActivation(!0));
    });
  }
  initVerticalAccordion() {
    (this.setActiveUpTo(0),
      this.setOnlyOpen(0),
      this.updateActiveContentFrom(0),
      this.items.forEach((t, e) => {
        let i = t.querySelector(".timeline-item__header");
        i &&
          i.addEventListener("click", () => {
            "true" !== i.getAttribute("aria-disabled") &&
              this.activateItem(e, { scrollIntoView: !1 });
          });
      }));
  }
  initHorizontalSliderClick() {
    (this.setActiveUpTo(0),
      this.setOnlyOpen(0),
      this.updateActiveContentFrom(0),
      this.attachItemClickActivation(!1),
      this.sliderComponent &&
        this.sliderComponent.addEventListener("slideChanged", (t) => {
          let e = t.detail || {},
            i = Number(e.currentPage);
          if (!i || Number.isNaN(i)) return;
          let s = i - 1;
          s < 0 || s >= this.items.length || this.activateItem(s, { scrollIntoView: !1 });
        }));
  }
  onHorizontalSliderIndexChange(t) {
    this.activateItem(t, { scrollIntoView: !1 });
  }
  alignMarkersToHeaders() {
    if (this.items?.length) {
      for (let t = 0; t < this.items.length; t++) {
        let e = this.items[t].querySelector(".timeline__point"),
          i = this.items[t].querySelector(".timeline__line");
        (e && (e.style.marginTop = ""), i && (i.style.marginBottom = ""));
      }
      for (let s = this.items.length - 1; s >= 0; s--) {
        let n = this.items[s],
          r = n.querySelector(".timeline-item__header"),
          o = n.querySelector(".timeline__point");
        if (!r || !o) continue;
        let a = r.offsetHeight || 0,
          l = o.offsetHeight || 0,
          d = Math.max(0, Math.round((a - l) / 2));
        if ((d > 0 && (o.style.marginTop = `${d}px`), s - 1 >= 0)) {
          let c = this.items[s - 1].querySelector(".timeline__line");
          c &&
            (d > 0
              ? (c.style.marginBottom = `calc((var(--items-spacing-vertical) - var(--line-point-spacing)) * -1 - ${d}px)`)
              : (c.style.marginBottom = ""));
        }
      }
    }
  }
  centerHorizontalItem(t) {
    if (!this.itemsContainer) return;
    let e = this.items[t];
    if (!e) return;
    let i = this.itemsContainer,
      s = i.getBoundingClientRect(),
      n = e.getBoundingClientRect(),
      r = s.width,
      o = i.scrollWidth - r,
      a = n.left - s.left + i.scrollLeft + n.width / 2,
      l = a - r / 2;
    ((l = Math.max(0, Math.min(l, o))), i.scrollTo({ left: l, behavior: "smooth" }));
  }
  disconnectedCallback() {
    ("function" == typeof this.detachScroll && this.detachScroll(),
      this._restoreTimer && (clearTimeout(this._restoreTimer), (this._restoreTimer = null)));
  }
}
customElements.define("hdl-timeline", HdlTimeline);
class TimelineSlider extends SliderComponent {
  constructor() {
    (super(),
      (this.timelineOwner = this.closest("hdl-timeline") || null),
      (this.currentIndex = 0));
  }
  get maxIndex() {
    return Math.max(0, this.sliderItemsToShow.length - 1);
  }
  clampIndex(t) {
    return Math.max(0, Math.min(t, this.maxIndex));
  }
  get isTimelineClickMode() {
    let t = this.timelineOwner;
    if (!t) return !1;
    let e = t.styleHorizontal,
      i = t.dataset.styleHorizontal;
    return "slider_click" === (e || i);
  }
  scrollToCenterIndex(t) {
    if (!this.slider || !this.sliderItemOffset) return;
    let e = this.slidesPerPage || 1,
      i = t - Math.floor(e / 2),
      s = Math.max(0, this.sliderItemsToShow.length - e);
    (i < 0 && (i = 0), i > s && (i = s));
    let n = i * this.sliderItemOffset;
    this.slider.scrollTo({ left: n * this.scrollMultiplier, behavior: "smooth" });
  }
  updateHorizontalArrows() {
    this.prevButton &&
      this.nextButton &&
      (this.currentIndex <= 0
        ? this.prevButton.setAttribute("disabled", "disabled")
        : this.prevButton.removeAttribute("disabled"),
      this.currentIndex >= this.maxIndex
        ? this.nextButton.setAttribute("disabled", "disabled")
        : this.nextButton.removeAttribute("disabled"));
  }
  goToIndex(t) {
    if (!this.isTimelineClickMode) return;
    let e = this.clampIndex(t);
    e !== this.currentIndex &&
      ((this.currentIndex = e),
      this.scrollToCenterIndex(this.currentIndex),
      this.updateHorizontalArrows(),
      this.timelineOwner &&
        "function" == typeof this.timelineOwner.onHorizontalSliderIndexChange &&
        this.timelineOwner.onHorizontalSliderIndexChange(this.currentIndex));
  }
  onButtonClick(t) {
    if (!this.isTimelineClickMode) return SliderComponent.prototype.onButtonClick.call(this, t);
    t.preventDefault();
    let e = "next" === t.currentTarget.name ? 1 : -1;
    this.goToIndex(this.currentIndex + e);
  }
  setCurrentIndexFromTimeline(t) {
    this.isTimelineClickMode && this.goToIndex(t);
  }
  update() {
    if (!this.isTimelineClickMode) return SliderComponent.prototype.update.call(this);
    this.updateHorizontalArrows();
  }
}
customElements.define("timeline-slider", TimelineSlider);
class JsonAnimation extends HTMLElement {
  constructor() {
    (super(),
      (this.animation = null),
      (this.currentUrl = null),
      (this.observer = null),
      (this.resizeTimeout = null),
      (this._initialized = !1),
      (this._onResize = this._onResize.bind(this)),
      (this._onClick = this._onClick.bind(this)));
  }
  connectedCallback() {
    if (!this._initialized) {
      if (((this._initialized = !0), !window.lottie || !window.lottie.loadAnimation)) {
        console.warn("<json-animation> requires lottie-web to be loaded.");
        return;
      }
      if (
        ((this.desktopUrl = this.getAttribute("animation-url") || this.dataset.animationUrl || ""),
        (this.mobileUrl =
          this.getAttribute("animation-url-mobile") || this.dataset.animationUrlMobile || ""),
        !this.desktopUrl)
      ) {
        console.warn("<json-animation> missing animation-url");
        return;
      }
      ((this.loop = this._getBoolAttr("loop", !0)),
        (this.autoplay = this._getBoolAttr("autoplay", !0)),
        (this.clickToPlay = this._getBoolAttr("click-to-play", !1)),
        (this.speed = parseFloat(this.getAttribute("speed") || this.dataset.speed) || 1),
        this.clickToPlay &&
          ((this.style.cursor = "pointer"), this.addEventListener("click", this._onClick)),
        this._loadAnimation(),
        window.addEventListener("resize", this._onResize));
    }
  }
  disconnectedCallback() {
    (window.removeEventListener("resize", this._onResize),
      this.removeEventListener("click", this._onClick),
      this.observer && (this.observer.disconnect(), (this.observer = null)),
      this.animation && (this.animation.destroy(), (this.animation = null)),
      clearTimeout(this.resizeTimeout));
  }
  _getBoolAttr(t, e) {
    if (!this.hasAttribute(t)) return e;
    let i = this.getAttribute(t);
    return "" === i || null === i || "true" === i || "1" === i;
  }
  _isMobile() {
    return window.innerWidth < 750;
  }
  _getAnimationUrl() {
    return this._isMobile() && this.mobileUrl ? this.mobileUrl : this.desktopUrl;
  }
  _onResize() {
    (clearTimeout(this.resizeTimeout),
      (this.resizeTimeout = setTimeout(() => {
        this._loadAnimation();
      }, 250)));
  }
  _onClick() {
    this.animation && (this.animation.isPaused ? this.animation.play() : this.animation.pause());
  }
  _setupObserver() {
    (this.observer && (this.observer.disconnect(), (this.observer = null)),
      this.autoplay ||
        ((this.observer = new IntersectionObserver(
          (t) => {
            t.forEach((t) => {
              this.animation &&
                (t.isIntersecting
                  ? (this.animation.play(), this.loop || this.observer.unobserve(this))
                  : this.loop && this.animation.pause());
            });
          },
          { threshold: 0.3 },
        )),
        this.observer.observe(this)));
  }
  _loadAnimation() {
    let t = this._getAnimationUrl();
    t &&
      ((this.currentUrl === t && this.animation) ||
        ((this.currentUrl = t),
        this.animation && (this.animation.destroy(), (this.animation = null)),
        (this.innerHTML = ""),
        (this.animation = window.lottie.loadAnimation({
          container: this,
          renderer: "svg",
          loop: this.loop,
          autoplay: this.autoplay,
          path: t,
        })),
        this.animation.setSpeed(this.speed),
        this._setupObserver()));
  }
}
customElements.define("json-animation", JsonAnimation);
class StickyGroupManager extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    ((this.stickyElements = []),
      this.collectStickyElements(),
      0 !== this.stickyElements.length &&
        ((this.currentScrollTop = 0),
        (this.preventReveal = !1),
        (this.groupBoundsBottom = 0),
        this.updateHeightsAndOffsets(),
        (this.mediaQuery = window.matchMedia("(max-width: 990px)")),
        this.mediaQuery.addEventListener("change", this.updateHeightsAndOffsets.bind(this)),
        (this.resizeObserver = new ResizeObserver(() => {
          this.updateHeightsAndOffsets();
        })),
        this.stickyElements.forEach((t) => {
          t.contentElement && this.resizeObserver.observe(t.contentElement);
        }),
        this.createObserver(),
        (this.onScrollHandler = this.onScroll.bind(this)),
        window.addEventListener("scroll", this.onScrollHandler, !1),
        (this.hideOnScrollUp = () => (this.preventReveal = !0)),
        this.addEventListener("preventHeaderReveal", this.hideOnScrollUp)));
  }
  collectStickyElements() {
    let t = this.querySelectorAll("sticky-header"),
      e = this.querySelectorAll("sticky-announcement"),
      i = [...e, ...t];
    (i.sort((t, e) => {
      let i = t.compareDocumentPosition(e);
      return i & Node.DOCUMENT_POSITION_FOLLOWING
        ? -1
        : i & Node.DOCUMENT_POSITION_PRECEDING
          ? 1
          : 0;
    }),
      i.forEach((t, e) => {
        let i = t.dataset.stickyType || "none";
        if ("none" === i) return;
        let s = "always" === i || "reduce-logo-size" === i,
          n = "sticky-header" === t.tagName.toLowerCase(),
          r;
        ((r = n
          ? t.closest(".section-header") || t.parentElement
          : t.closest(".shopify-section") || t.parentElement),
          this.stickyElements.push({
            element: t,
            contentElement: r,
            type: i,
            index: e,
            height: 0,
            isHidden: !1,
            isAlwaysSticky: s,
            isHeader: n,
          }),
          (t.dataset.managedByGroup = "true"),
          s && r && r.classList.add("shopify-section-header-sticky"));
      }));
  }
  updateHeightsAndOffsets() {
    let t = 0;
    (this.stickyElements.forEach((e) => {
      if (e.contentElement) {
        e.height = e.contentElement.getBoundingClientRect().height;
        let i = Math.ceil(e.height);
        e.isHeader
          ? e.contentElement.style.setProperty("--header-height", `${i}px`)
          : e.contentElement.style.setProperty("--announcement-bar-height", `${i}px`);
      }
      let s = Math.floor(t);
      (e.element.style.setProperty("--sticky-offset", `${s}px`),
        e.contentElement && e.contentElement.style.setProperty("--sticky-offset", `${s}px`),
        e.isHidden || (t += e.height));
    }),
      document.documentElement.style.setProperty("--sticky-group-height", `${Math.floor(t)}px`));
    let e = this.stickyElements.find((t) => t.isHeader);
    e && document.documentElement.style.setProperty("--header-height", `${Math.ceil(e.height)}px`);
  }
  createObserver() {
    let t = new IntersectionObserver((t) => {
      this.groupBoundsBottom = t[0].boundingClientRect.bottom;
    });
    t.observe(this);
  }
  onScroll() {
    let t = window.scrollY || document.documentElement.scrollTop,
      e = t > this.currentScrollTop,
      i = t < this.currentScrollTop,
      s = this.getBoundingClientRect(),
      n = t > s.height,
      r = t <= 0,
      o = this.stickyElements.some((t) => {
        if (t.isHeader) {
          let e = t.element.querySelector("predictive-search");
          return e && e.isOpen;
        }
        return !1;
      });
    if (o) {
      this.currentScrollTop = t;
      return;
    }
    (this.stickyElements.forEach((t) => {
      if (r) this.resetElement(t);
      else if (n) {
        if ((t.contentElement?.classList.add("scrolled-past-header"), e)) {
          if (this.preventHide) return;
          requestAnimationFrame(() => this.hideElement(t));
        } else
          i &&
            (this.preventReveal
              ? (clearTimeout(this.isScrolling),
                (this.isScrolling = setTimeout(() => {
                  this.preventReveal = !1;
                }, 66)),
                requestAnimationFrame(() => this.hideElement(t)))
              : requestAnimationFrame(() => this.revealElement(t)));
      } else
        t.isAlwaysSticky &&
          (t.contentElement?.classList.add("scrolled-past-header"), this.revealElement(t));
    }),
      (this.currentScrollTop = t));
  }
  hideElement(t) {
    !t.isAlwaysSticky &&
      t.contentElement &&
      ((t.isHidden = !0),
      t.contentElement.classList.add(
        "shopify-section-header-hidden",
        "shopify-section-header-sticky",
      ),
      this.updateVisibleOffsets(),
      t.element.dispatchEvent(new CustomEvent("stickyHide", { bubbles: !0 })));
  }
  revealElement(t) {
    t.contentElement &&
      ((t.isHidden = !1),
      t.contentElement.classList.add("shopify-section-header-sticky", "animate"),
      t.contentElement.classList.remove("shopify-section-header-hidden"),
      this.updateVisibleOffsets(),
      t.element.dispatchEvent(new CustomEvent("stickyReveal", { bubbles: !0 })));
  }
  resetElement(t) {
    if (t.contentElement) {
      if ((t.contentElement.classList.remove("scrolled-past-header"), t.isAlwaysSticky)) {
        t.element.dispatchEvent(new CustomEvent("stickyReset", { bubbles: !0 }));
        return;
      }
      ((t.isHidden = !1),
        t.contentElement.classList.remove(
          "shopify-section-header-hidden",
          "shopify-section-header-sticky",
          "animate",
        ),
        this.updateVisibleOffsets(),
        t.element.dispatchEvent(new CustomEvent("stickyReset", { bubbles: !0 })));
    }
  }
  updateVisibleOffsets() {
    let t = 0;
    (this.stickyElements.forEach((e) => {
      let i = Math.floor(t);
      (e.element.style.setProperty("--sticky-offset", `${i}px`),
        e.contentElement && e.contentElement.style.setProperty("--sticky-offset", `${i}px`),
        e.isHidden || (t += e.height));
    }),
      document.documentElement.style.setProperty("--sticky-group-height", `${Math.floor(t)}px`));
  }
  disconnectedCallback() {
    (window.removeEventListener("scroll", this.onScrollHandler),
      this.mediaQuery?.removeEventListener("change", this.updateHeightsAndOffsets.bind(this)),
      this.removeEventListener("preventHeaderReveal", this.hideOnScrollUp),
      this.resizeObserver?.disconnect());
  }
}
customElements.define("sticky-group-manager", StickyGroupManager);
class StickyAnnouncement extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    ((this.announcementBar = this.querySelector(".announcement-bar")),
      "true" !== this.dataset.managedByGroup && this.initIndependentSticky(),
      this.addEventListener("stickyHide", this.onHide.bind(this)),
      this.addEventListener("stickyReveal", this.onReveal.bind(this)),
      this.addEventListener("stickyReset", this.onReset.bind(this)));
  }
  initIndependentSticky() {
    let t = this.dataset.stickyType;
    "always" === t && this.announcementBar?.classList.add("shopify-section-header-sticky");
  }
  onHide() {}
  onReveal() {}
  onReset() {}
}
customElements.define("sticky-announcement", StickyAnnouncement);
class InfiniteProducts extends HTMLElement {
  constructor() {
    (super(),
      (this.sentinel = this.querySelector("[data-infinite-sentinel]")),
      (this.loading = !1),
      (this.observer = null));
  }
  connectedCallback() {
    this.sentinel &&
      ((this.observer = new IntersectionObserver(
        (t) => {
          t[0].isIntersecting && !this.loading && this.loadMore();
        },
        { rootMargin: "400px 0px" },
      )),
      this.observer.observe(this.sentinel));
  }
  disconnectedCallback() {
    this.observer && this.observer.disconnect();
  }
  async loadMore() {
    let t = this.sentinel.dataset.nextUrl,
      e = document.getElementById("product-grid");
    if (t && e) {
      ((this.loading = !0), this.sentinel.classList.add("infinite-sentinel--loading"));
      try {
        let i = await fetch(t);
        if (!i.ok) throw Error(`Request failed: ${i.status}`);
        let s = await i.text(),
          n = new DOMParser().parseFromString(s, "text/html"),
          r = n.getElementById("product-grid");
        if (r) {
          let o = r.querySelectorAll(":scope > li");
          o.forEach((t) => e.appendChild(t));
        }
        let a = n.querySelector("[data-infinite-sentinel]"),
          l = a?.dataset.nextUrl;
        l
          ? (this.sentinel.dataset.nextUrl = l)
          : (this.observer.disconnect(), this.sentinel.remove());
      } catch (d) {
        console.error("Infinite load failed:", d);
      } finally {
        ((this.loading = !1), this.sentinel?.classList.remove("infinite-sentinel--loading"));
      }
    }
  }
}
function _formatPresentmentMoney(t, e) {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || void 0, {
      style: "currency",
      currency: e,
    }).format(t / 100);
  } catch (i) {
    return (t / 100).toFixed(2) + " " + e;
  }
}
function _getPresentmentRate(t) {
  let e = window.Shopify && window.Shopify.currency && window.Shopify.currency.active,
    i = window.Shopify && window.Shopify.currency && window.Shopify.currency.rate;
  if (!e || !i || e === t) return null;
  let s = parseFloat(i);
  return s && 1 !== s ? { active: e, rate: s } : null;
}
customElements.define("infinite-products", InfiniteProducts);
class CartProgressBar extends HTMLElement {
  connectedCallback() {
    this.update();
  }
  update() {
    if ("true" === this.dataset.isQuantity) return;
    let t = _getPresentmentRate(this.dataset.shopCurrency);
    if (!t) return;
    let e = parseFloat(this.dataset.goalShopCents) * t.rate,
      i = parseFloat(this.dataset.cartTotalCents),
      s = "true" === this.dataset.subAutoComplete,
      n = Math.min(100, (i / e) * 100),
      r = s || n >= 100,
      o = this.querySelector(".cart-progress__bar__progress");
    o && (o.style.width = (r ? 100 : n) + "%");
    let a = this.querySelector(".cart-progress__text");
    if (a) {
      if (r) a.innerHTML = this.dataset.successMessage || "";
      else {
        let l = _formatPresentmentMoney(Math.max(0, e - i), t.active);
        a.innerHTML = (this.dataset.progressMessage || "").replace(
          "[amount]",
          "<span>" + l + "</span>",
        );
      }
    }
  }
}
customElements.define("cart-progress-bar", CartProgressBar);
class CartCheckpointsBar extends HTMLElement {
  connectedCallback() {
    this.update();
  }
  update() {
    if ("true" === this.dataset.isQuantity) return;
    let t = _getPresentmentRate(this.dataset.shopCurrency);
    if (!t) return;
    let e;
    try {
      e = JSON.parse(this.dataset.goals || "[]");
    } catch (i) {
      return;
    }
    if (!e.length) return;
    let s = parseFloat(this.dataset.cartTotalCents),
      n = e[e.length - 1].cents * t.rate,
      r = null;
    for (let o of e) {
      let a = o.cents * t.rate;
      if (a > s) {
        r = { cents: a, text: o.text };
        break;
      }
    }
    let l = this.querySelector(".cart-progress__bar__progress");
    l && (l.style.width = (r ? Math.min(100, (s / n) * 100) : 100) + "%");
    let d = this.querySelector(".cart-progress__text");
    if (d) {
      if (r) {
        let c = Math.max(0, r.cents - s),
          h = _formatPresentmentMoney(c, t.active);
        d.innerHTML = (this.dataset.progressMessage || "")
          .replace("[amount]", "<span>" + h + "</span>")
          .replace("[next_goal]", r.text || "");
      } else d.innerHTML = this.dataset.successMessage || "";
    }
  }
}
customElements.define("cart-checkpoints-bar", CartCheckpointsBar);
